import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withKeys as _withKeys, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fd649a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "assistant-header" }
const _hoisted_3 = { class: "assistant-header-identity" }
const _hoisted_4 = {
  class: "assistant-header-avatar",
  "aria-hidden": "true"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "assistant-header-copy" }
const _hoisted_8 = { class: "assistant-title" }
const _hoisted_9 = { class: "assistant-subtitle" }
const _hoisted_10 = ["aria-label"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["aria-label"]
const _hoisted_13 = { class: "assistant-support-head" }
const _hoisted_14 = { class: "assistant-support-title" }
const _hoisted_15 = { class: "assistant-support-subtitle" }
const _hoisted_16 = ["aria-label", "disabled"]
const _hoisted_17 = { class: "assistant-support-field" }
const _hoisted_18 = { class: "assistant-support-field" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "assistant-support-field" }
const _hoisted_21 = { class: "assistant-support-file" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 0,
  class: "assistant-support-files"
}
const _hoisted_24 = ["disabled", "onClick"]
const _hoisted_25 = { class: "assistant-support-context" }
const _hoisted_26 = {
  key: 1,
  class: "assistant-alert assistant-alert--error"
}
const _hoisted_27 = { class: "assistant-support-actions" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = ["disabled"]
const _hoisted_30 = ["aria-expanded"]
const _hoisted_31 = {
  key: 0,
  class: "assistant-language-card"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "assistant-language-greeting" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Сәлеметсіз бе! Менің атым Аян. Тілді таңдаңыз."),
  /*#__PURE__*/_createElementVNode("div", null, "Здравствуйте! Меня зовут Аян. Выберите язык."),
  /*#__PURE__*/_createElementVNode("div", null, "Hello! My name is Ayan. Please choose a language.")
], -1))
const _hoisted_33 = { class: "assistant-language-actions" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 1,
  class: "assistant-language-switcher"
}
const _hoisted_36 = ["disabled", "onClick"]
const _hoisted_37 = {
  key: 2,
  class: "assistant-alert assistant-alert--error"
}
const _hoisted_38 = {
  key: 4,
  class: "assistant-welcome-card"
}
const _hoisted_39 = {
  key: 5,
  class: "assistant-menu"
}
const _hoisted_40 = { class: "assistant-menu-head" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = { class: "assistant-menu-title" }
const _hoisted_43 = { class: "assistant-menu-subtitle" }
const _hoisted_44 = ["disabled", "onClick"]
const _hoisted_45 = ["disabled", "onClick"]
const _hoisted_46 = ["disabled", "onClick"]
const _hoisted_47 = { class: "assistant-category-title" }
const _hoisted_48 = { class: "assistant-category-meta" }
const _hoisted_49 = ["disabled", "onClick"]
const _hoisted_50 = {
  key: 0,
  class: "assistant-related-topics"
}
const _hoisted_51 = { class: "assistant-menu-head" }
const _hoisted_52 = { class: "assistant-menu-title" }
const _hoisted_53 = { class: "assistant-menu-subtitle" }
const _hoisted_54 = ["disabled", "onClick"]
const _hoisted_55 = { class: "assistant-category-title" }
const _hoisted_56 = { class: "assistant-category-meta" }
const _hoisted_57 = {
  key: 1,
  class: "assistant-menu-navigation"
}
const _hoisted_58 = ["disabled"]
const _hoisted_59 = ["disabled"]
const _hoisted_60 = {
  key: 0,
  class: "assistant-history-title"
}
const _hoisted_61 = {
  key: 0,
  class: "assistant-message-avatar",
  "aria-hidden": "true"
}
const _hoisted_62 = ["src"]
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { class: "assistant-message-body" }
const _hoisted_65 = { class: "assistant-message-content" }
const _hoisted_66 = {
  key: 0,
  class: "assistant-actions"
}
const _hoisted_67 = ["aria-label", "title", "disabled", "onClick"]
const _hoisted_68 = { class: "assistant-file-copy" }
const _hoisted_69 = { class: "assistant-file-title" }
const _hoisted_70 = {
  key: 0,
  class: "assistant-file-name"
}
const _hoisted_71 = {
  key: 1,
  class: "assistant-actions"
}
const _hoisted_72 = ["disabled", "onClick"]
const _hoisted_73 = {
  key: 2,
  class: "assistant-feedback"
}
const _hoisted_74 = { key: 0 }
const _hoisted_75 = ["disabled", "onClick"]
const _hoisted_76 = ["disabled", "onClick"]
const _hoisted_77 = { key: 1 }
const _hoisted_78 = {
  key: 1,
  class: "assistant-message assistant-message--assistant"
}
const _hoisted_79 = {
  class: "assistant-message-avatar",
  "aria-hidden": "true"
}
const _hoisted_80 = ["src"]
const _hoisted_81 = { key: 1 }
const _hoisted_82 = { class: "assistant-message-body" }
const _hoisted_83 = { class: "assistant-message-content" }
const _hoisted_84 = {
  key: 2,
  class: "assistant-hr-search"
}
const _hoisted_85 = { role: "status" }
const _hoisted_86 = { class: "assistant-actions" }
const _hoisted_87 = ["disabled"]
const _hoisted_88 = ["disabled"]
const _hoisted_89 = ["disabled"]
const _hoisted_90 = ["disabled"]
const _hoisted_91 = ["disabled"]
const _hoisted_92 = {
  key: 0,
  class: "assistant-support-links"
}
const _hoisted_93 = ["disabled"]
const _hoisted_94 = ["disabled"]
const _hoisted_95 = ["aria-label", "placeholder", "disabled", "onKeydown"]
const _hoisted_96 = ["disabled"]
const _hoisted_97 = ["aria-expanded", "aria-label"]
const _hoisted_98 = /*#__PURE__*/_createTextVNode(" AI ")
const _hoisted_99 = {
  key: 0,
  class: "assistant-launcher-badge",
  "aria-hidden": "true"
}

import {
  computed,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  ChevronRightIcon,
  DocumentTextIcon,
  XIcon,
} from "@heroicons/vue/outline";
import { useStore } from "vuex";
import { AuthGetters } from "@/store/modules/auth";
import { accountKey } from "@/utils/accountSession";
import AssistantDataService from "@/services/assistant/AssistantDataService";
import HrDataService from "@/services/hr/HrDataService";
import HelpdeskDataService from "@/services/helpdesk/HelpdeskDataService";
import { ASSISTANT_AVATAR_UPDATED_EVENT } from "@/services/helpdesk/HelpdeskRealtime";
import {
  ASSISTANT_ERROR_EVENT_NAME,
  isAssistantErrorCode,
} from "@/services/assistant/AssistantErrorEventBus";
import type {
  AssistantErrorCode,
  AssistantErrorEventDetail,
} from "@/services/assistant/AssistantErrorEventBus";
import {
  AssistantAction,
  AssistantBootstrapResponse,
  AssistantMessageResponse,
  AssistantSuggestion,
} from "@/types/assistant/Assistant";
import { checkNcaLayerConnection } from "@/utils/ncaLayer";
import type { TicketCategory } from "@/types/helpdesk/Helpdesk";
import { consumeAssistantAutoOpen } from "@/utils/assistantAutoOpen";
import { downloadBlob } from "@/utils/downloadBlob";

type ChatSender = "user" | "assistant" | "system";
type NcaStatus = "UNKNOWN" | "CHECKING" | "AVAILABLE" | "UNAVAILABLE";
type AssistantLanguage = "kk" | "ru" | "en";
type AssistantMenuView = "page" | "pageQuestions" | "allTopics";

interface ChatMessage {
  id: string;
  sender: ChatSender;
  text: string;
  messageId?: string;
  intent?: string;
  actions?: AssistantAction[];
  feedback?: boolean | null;
}

interface HrDocumentContinuation {
  messageId: string;
  query: string;
  employeeId: string | null;
  page: number;
  unclassified: boolean;
  previousQuery?: string | null;
}

interface SupportForm {
  subject: string;
  description: string;
  category: TicketCategory;
  includeTechnicalContext: boolean;
}

interface SuggestionCategory {
  key: string;
  title: string;
  description: string;
  intents: string[];
  items: AssistantSuggestion[];
}

interface CategoryDefinition {
  key: string;
  title: Record<AssistantLanguage, string>;
  description: Record<AssistantLanguage, string>;
  intents: string[];
}

interface PageSuggestionContext {
  key: string;
  routeNames?: string[];
  exactPaths?: string[];
  pathPrefixes?: string[];
  suggestionCodes: string[];
  fallbackIntents: string[];
  categoryKeys: string[];
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const LANGUAGE_STORAGE_KEY = "assistant-language";
const MAX_CONTEXTUAL_SUGGESTIONS = 4;
const ERROR_EVENT_DEDUPE_MS = 30000;
const ERROR_CONTEXT_TTL_MS = 5 * 60 * 1000;

const languages: Array<{
  code: AssistantLanguage;
  label: string;
  shortLabel: string;
}> = [
  { code: "kk", label: "Қазақша", shortLabel: "Қаз" },
  { code: "ru", label: "Русский", shortLabel: "Рус" },
  { code: "en", label: "English", shortLabel: "Eng" },
];

const assistantTexts: Record<
  AssistantLanguage,
  {
    title: string;
    subtitle: string;
    open: string;
    close: string;
    language: string;
    readyQuestions: string;
    chooseTopic: string;
    pageSuggestions: string;
    pageSuggestionsHint: string;
    relatedTopics: string;
    relatedTopicsHint: string;
    allPageQuestions: string;
    allPageQuestionsHint: string;
    allTopics: string;
    dialogTitle: string;
    back: string;
    answerHelpful: string;
    yes: string;
    no: string;
    feedbackThanks: string;
    loading: string;
    placeholder: string;
    chooseLanguageFirst: string;
    send: string;
    bootstrapError: string;
    supportHint: string;
    navigationBlocked: string;
    ncaChecking: string;
    ncaAvailable: string;
    ncaUnavailable: string;
    ncaAvailableMessage: string;
    ncaUnavailableMessage: string;
    feedbackError: string;
    answerError: string;
    urlMissing: string;
    urlUnsafe: string;
    languageChanged: string;
    welcome: string;
  }
> = {
  kk: {
    title: "Аян",
    subtitle: "Цифрлық көмекші",
    open: "Көмекшіні ашу",
    close: "Көмекшіні жабу",
    language: "Тіл",
    readyQuestions: "Дайын сұрақтар",
    chooseTopic: "Тақырыпты, содан кейін сұрақты таңдаңыз",
    pageSuggestions: "Осы бетке арналған өзекті дайын сұрақтар",
    pageSuggestionsHint: "Ашық бөлімде жиі қажет болатын сұрақтар",
    relatedTopics: "Осы бөлімге қатысты тақырыптар",
    relatedTopicsHint: "Қажетті тақырыпты таңдаңыз",
    allPageQuestions: "Осы бет бойынша барлық сұрақтар",
    allPageQuestionsHint: "Ашық бөлімге қатысты барлық дайын сұрақтар",
    allTopics: "Барлық тақырыптар",
    dialogTitle: "Аянмен диалог",
    back: "Артқа",
    answerHelpful: "Жауап көмектесті ме?",
    yes: "Иә",
    no: "Жоқ",
    feedbackThanks: "Бағаңызға рақмет",
    loading: "Сәйкес жауап іздеп жатырмын...",
    placeholder: "Сұрақ жазыңыз...",
    chooseLanguageFirst: "Алдымен тілді таңдаңыз...",
    send: "Жіберу",
    bootstrapError:
      "Көмекші кеңестерін жүктеу мүмкін болмады. Кейінірек көріңіз.",
    supportHint:
      "Қате қайталанса, қолдау қызметіне әрекеттің, бөлімнің және қате уақытының қысқаша сипаттамасын беріңіз.",
    navigationBlocked:
      "Бөлімді ашу мүмкін болмады: жол қауіпсіздік тексеруінен өтпеді.",
    ncaChecking: "NCALayer қосылымын тексеріп жатырмын...",
    ncaAvailable: "NCALayer қолжетімді.",
    ncaUnavailable:
      "NCALayer жауап бермейді. Оның орнатылғанын және іске қосылғанын тексеріңіз.",
    ncaAvailableMessage:
      "NCALayer қолжетімді. Кіруді немесе қол қоюды қайталауға болады.",
    ncaUnavailableMessage:
      "NCALayer жауап бермейді. NCALayer іске қосыңыз, бетті жаңартыңыз және әрекетті қайталаңыз.",
    feedbackError: "Жауап бағасын сақтау мүмкін болмады.",
    answerError:
      "Көмекшіден жауап алу мүмкін болмады. Қосылымды тексеріп, қайта көріңіз.",
    urlMissing: "Сілтеме әзірге бапталмаған.",
    urlUnsafe: "Сілтеме қауіпсіздік тексеруінен өтпеді.",
    languageChanged:
      "Тіл қазақ тіліне ауыстырылды. Енді жауаптар қазақ тілінде беріледі.",
    welcome:
      "Сәлеметсіз бе, менің атым Аян. Мен сіздің цифрлық көмекшіңізбін. Қажетті бөлімді табуға, құжаттарға қол қоюды, NCALayer жұмысын және қолжетімділік құқықтарын түсінуге көмектесемін.",
  },
  ru: {
    title: "Аян",
    subtitle: "Цифровой помощник",
    open: "Открыть помощника",
    close: "Закрыть помощника",
    language: "Язык",
    readyQuestions: "Готовые вопросы",
    chooseTopic: "Выберите тему, а затем подходящий вопрос",
    pageSuggestions: "Актуальные готовые вопросы для этой страницы",
    pageSuggestionsHint: "Частые вопросы для текущего раздела",
    relatedTopics: "Темы, связанные с этим разделом",
    relatedTopicsHint: "Выберите подходящую категорию",
    allPageQuestions: "Все вопросы по этой странице",
    allPageQuestionsHint: "Все готовые вопросы для текущего раздела",
    allTopics: "Все темы",
    dialogTitle: "Диалог с Аяном",
    back: "Назад",
    answerHelpful: "Ответ помог?",
    yes: "Да",
    no: "Нет",
    feedbackThanks: "Спасибо за оценку",
    loading: "Ищу подходящий ответ...",
    placeholder: "Напишите вопрос...",
    chooseLanguageFirst: "Сначала выберите язык...",
    send: "Отправить",
    bootstrapError:
      "Не получилось загрузить подсказки помощника. Попробуйте позже.",
    supportHint:
      "Если ошибка повторяется, передайте в поддержку краткое описание действия, раздел и время возникновения ошибки.",
    navigationBlocked:
      "Не удалось открыть раздел: путь не прошел проверку безопасности.",
    ncaChecking: "Проверяю подключение к NCALayer...",
    ncaAvailable: "NCALayer доступен.",
    ncaUnavailable:
      "NCALayer не отвечает. Проверьте, что он установлен и запущен.",
    ncaAvailableMessage:
      "NCALayer доступен. Можно повторить вход или подписание.",
    ncaUnavailableMessage:
      "NCALayer не отвечает. Запустите NCALayer, обновите страницу и повторите действие.",
    feedbackError: "Не удалось сохранить оценку ответа.",
    answerError:
      "Не получилось получить ответ помощника. Проверьте соединение и попробуйте еще раз.",
    urlMissing: "Ссылка пока не настроена.",
    urlUnsafe: "Ссылка не прошла проверку безопасности.",
    languageChanged:
      "Язык переключен на русский. Дальше буду отвечать на русском.",
    welcome:
      "Здравствуйте, меня зовут Аян. Я ваш цифровой помощник. Я помогу найти нужный раздел, разобраться с подписанием документов, NCALayer и правами доступа.",
  },
  en: {
    title: "Ayan",
    subtitle: "Digital Assistant",
    open: "Open assistant",
    close: "Close assistant",
    language: "Language",
    readyQuestions: "Ready questions",
    chooseTopic: "Choose a topic, then select a question",
    pageSuggestions: "Relevant ready questions for this page",
    pageSuggestionsHint: "Common questions for the current section",
    relatedTopics: "Topics related to this section",
    relatedTopicsHint: "Choose a relevant category",
    allPageQuestions: "All questions for this page",
    allPageQuestionsHint: "All ready questions for the current section",
    allTopics: "All topics",
    dialogTitle: "Chat with Ayan",
    back: "Back",
    answerHelpful: "Was this answer helpful?",
    yes: "Yes",
    no: "No",
    feedbackThanks: "Thanks for the feedback",
    loading: "Looking for a suitable answer...",
    placeholder: "Type your question...",
    chooseLanguageFirst: "Choose a language first...",
    send: "Send",
    bootstrapError: "Could not load assistant tips. Please try again later.",
    supportHint:
      "If the error repeats, send support a short description of the action, section, and error time.",
    navigationBlocked:
      "Could not open the section: the path did not pass the security check.",
    ncaChecking: "Checking NCALayer connection...",
    ncaAvailable: "NCALayer is available.",
    ncaUnavailable:
      "NCALayer is not responding. Check that it is installed and running.",
    ncaAvailableMessage:
      "NCALayer is available. You can try logging in or signing again.",
    ncaUnavailableMessage:
      "NCALayer is not responding. Start NCALayer, refresh the page, and try again.",
    feedbackError: "Could not save the answer rating.",
    answerError:
      "Could not get an assistant response. Check the connection and try again.",
    urlMissing: "The link is not configured yet.",
    urlUnsafe: "The link did not pass the security check.",
    languageChanged:
      "Language switched to English. I will answer in English from now on.",
    welcome:
      "Hello, my name is Ayan. I am your digital assistant. I can help you find the right section and understand document signing, NCALayer, and access rights.",
  },
};

const hrAssistantTexts: Record<
  AssistantLanguage,
  {
    employeeSelected: string;
    showEmployeeDocuments: string;
    downloadError: string;
    employeeSearchHint: string;
    documentSearchHint: string;
    otherEmployee: string;
    otherDocument: string;
    allEmployeeDocuments: string;
    finishSearch: string;
    searchFinished: string;
    showMore: string;
    showUnclassified: string;
    showClassified: string;
  }
> = {
  kk: {
    employeeSelected: "Қызметкер таңдалды",
    showMore: "Тағы көрсету",
    showUnclassified: "Бөлінбеген құжаттар",
    showClassified: "Санаттарға бөлінген құжаттар",
    employeeSearchHint:
      "Тізімнен қызметкерді таңдаңыз немесе басқа атын / тегін енгізіңіз.",
    documentSearchHint:
      "Құжатты таңдаңыз немесе іздеуді жалғастыру үшін атауын енгізіңіз.",
    otherEmployee: "Басқа қызметкерді таңдау",
    otherDocument: "Басқа құжатты табу",
    allEmployeeDocuments: "Қызметкердің барлық құжаттары",
    finishSearch: "Іздеуді аяқтау",
    searchFinished:
      "Іздеу аяқталды. Таңдалған қызметкер мен құжаттар контексті тазартылды.",
    showEmployeeDocuments: "Қызметкердің құжаттарын көрсет",
    downloadError:
      "Құжатты ашу мүмкін болмады. Қолжетімділікті тексеріп, қайталап көріңіз.",
  },
  ru: {
    employeeSelected: "Выбран сотрудник",
    showMore: "Показать ещё",
    showUnclassified: "Нераспределённые файлы",
    showClassified: "Распределённые файлы",
    employeeSearchHint:
      "Выберите сотрудника из списка или введите другое имя / фамилию.",
    documentSearchHint:
      "Выберите документ или введите название, чтобы продолжить поиск.",
    otherEmployee: "Выбрать другого сотрудника",
    otherDocument: "Найти другой документ",
    allEmployeeDocuments: "Все документы сотрудника",
    finishSearch: "Завершить поиск",
    searchFinished:
      "Поиск завершён. Выбранный сотрудник и контекст документов очищены.",
    showEmployeeDocuments: "Покажи документы сотрудника",
    downloadError:
      "Не удалось открыть документ. Проверьте доступ и попробуйте ещё раз.",
  },
  en: {
    employeeSelected: "Employee selected",
    showMore: "Show more",
    showUnclassified: "Unclassified files",
    showClassified: "Classified files",
    employeeSearchHint:
      "Select an employee from the list or enter another name / surname.",
    documentSearchHint:
      "Select a document or enter a title to continue searching.",
    otherEmployee: "Choose another employee",
    otherDocument: "Find another document",
    allEmployeeDocuments: "All employee documents",
    finishSearch: "Finish search",
    searchFinished:
      "Search finished. The selected employee and document context have been cleared.",
    showEmployeeDocuments: "Show the employee documents",
    downloadError:
      "Could not open the document. Check your access and try again.",
  },
};

const supportTexts: Record<
  AssistantLanguage,
  {
    open: string;
    title: string;
    subtitle: string;
    subject: string;
    category: string;
    description: string;
    attachments: string;
    attachmentsHint: string;
    includeContext: string;
    remove: string;
    cancel: string;
    submit: string;
    sending: string;
    required: string;
    fileError: string;
    createError: string;
    created: (ticketNumber: string) => string;
    partialUpload: string;
    openTicket: string;
    myTickets: string;
    categories: Record<TicketCategory, string>;
  }
> = {
  kk: {
    open: "Әкімшіге өтініш жіберу",
    title: "Helpdesk өтініші",
    subtitle: "Мәселені сипаттаңыз. Жеке деректерді енгізбеңіз.",
    subject: "Тақырыбы",
    category: "Санаты",
    description: "Сипаттамасы",
    attachments: "Суреттер",
    attachmentsHint: "JPEG немесе PNG, 5 файлға дейін, әрқайсысы 10 МБ-тан аспасын. Скриншотты Ctrl+V арқылы кірістіруге болады.",
    includeContext: "Ағымдағы бөлімді және қате кодын қосу",
    remove: "Жою",
    cancel: "Болдырмау",
    submit: "Өтінішті жіберу",
    sending: "Жіберілуде...",
    required: "Тақырып пен сипаттаманы толтырыңыз.",
    fileError: "Тек JPEG және PNG суреттерін қосуға болады.",
    createError: "Өтінішті жіберу мүмкін болмады. Қайта көріңіз.",
    created: (ticketNumber) => `${ticketNumber} өтініші құрылды.`,
    partialUpload: "Кейбір суреттер жүктелмеді, бірақ өтініш сақталды.",
    openTicket: "Өтінішті ашу",
    myTickets: "Менің өтініштерім",
    categories: {
      QUESTION: "Сұрақ",
      BUG: "Қате",
      ACCESS: "Қолжетімділік",
      SIGNATURE: "Қол қою",
      NCALAYER: "NCALayer",
      OTHER: "Басқа",
    },
  },
  ru: {
    open: "Оставить обращение",
    title: "Обращение в Helpdesk",
    subtitle: "Опишите проблему. Не указывайте пароли, ИИН или данные ЭЦП.",
    subject: "Тема",
    category: "Категория",
    description: "Описание",
    attachments: "Изображения",
    attachmentsHint: "JPEG или PNG, до 5 файлов, не более 10 МБ каждый. Скриншот можно вставить через Ctrl+V.",
    includeContext: "Приложить текущий раздел и код ошибки",
    remove: "Удалить",
    cancel: "Отмена",
    submit: "Отправить обращение",
    sending: "Отправка...",
    required: "Заполните тему и описание.",
    fileError: "Можно прикрепить только JPEG и PNG изображения.",
    createError: "Не удалось отправить обращение. Попробуйте еще раз.",
    created: (ticketNumber) => `Обращение ${ticketNumber} создано.`,
    partialUpload: "Часть изображений не загрузилась, но обращение сохранено.",
    openTicket: "Открыть обращение",
    myTickets: "Мои обращения",
    categories: {
      QUESTION: "Вопрос",
      BUG: "Ошибка",
      ACCESS: "Доступ",
      SIGNATURE: "Подписание",
      NCALAYER: "NCALayer",
      OTHER: "Другое",
    },
  },
  en: {
    open: "Create support ticket",
    title: "Helpdesk ticket",
    subtitle: "Describe the issue. Do not include passwords, personal IDs, or digital signature data.",
    subject: "Subject",
    category: "Category",
    description: "Description",
    attachments: "Images",
    attachmentsHint: "JPEG or PNG, up to 5 files, no more than 10 MB each. You can paste a screenshot with Ctrl+V.",
    includeContext: "Include the current section and error code",
    remove: "Remove",
    cancel: "Cancel",
    submit: "Submit ticket",
    sending: "Submitting...",
    required: "Enter a subject and description.",
    fileError: "Only JPEG and PNG images can be attached.",
    createError: "Could not submit the ticket. Please try again.",
    created: (ticketNumber) => `Ticket ${ticketNumber} was created.`,
    partialUpload: "Some images were not uploaded, but the ticket was saved.",
    openTicket: "Open ticket",
    myTickets: "My tickets",
    categories: {
      QUESTION: "Question",
      BUG: "Bug",
      ACCESS: "Access",
      SIGNATURE: "Signing",
      NCALAYER: "NCALayer",
      OTHER: "Other",
    },
  },
};

const assistantErrorHints: Record<
  AssistantLanguage,
  Record<AssistantErrorCode, string>
> = {
  kk: {
    SESSION_EXPIRED:
      "Сессия аяқталған сияқты. Жүйеге қайта кіріп, әрекетті қайталаңыз.",
    ACCESS_DENIED_SECTION:
      "Бұл бөлімге қолжетімділік жоқ сияқты. Қажет болса, әкімшіге хабарласыңыз.",
    ACCESS_DENIED_DOCUMENT:
      "Бұл құжатқа қолжетімділік жоқ сияқты. Қолжетімділікті құжат бастамашысынан немесе жауапты қызметкерден сұраңыз.",
    PAGE_NOT_FOUND:
      "Бет табылмады. Бетті жаңартып көріңіз немесе сілтеменің өзекті екенін тексеріңіз.",
    SERVICE_UNAVAILABLE:
      "Сервис уақытша жауап бермейді. Бетті жаңартып көріңіз. Қате қайталанса, қолдау қызметіне хабарласыңыз.",
    FILE_UPLOAD_ERROR:
      "Файлды жүктеу кезінде қате болды. Файлды тексеріп, қайта жүктеп көріңіз.",
    FILE_TOO_LARGE:
      "Файл тым үлкен сияқты. Файлды кішірейтіп немесе басқа файлды жүктеп көріңіз.",
    FILE_OPEN_ERROR:
      "Файлды ашу немесе жүктеп алу мүмкін болмады. Бетті жаңартып, әрекетті қайталаңыз.",
    NOTIFICATION_COUNTER_NOT_UPDATED:
      "Хабарламалар есептегіші жаңармады. Бетті жаңартыңыз, егер есептегіш жаңармаса, қолдау қызметіне хабарласыңыз.",
  },
  ru: {
    SESSION_EXPIRED:
      "Похоже, сессия истекла. Войдите заново и повторите действие.",
    ACCESS_DENIED_SECTION:
      "Похоже, у вас нет доступа к этому разделу. Если доступ нужен, обратитесь к администратору.",
    ACCESS_DENIED_DOCUMENT:
      "Похоже, у вас нет доступа к этому документу. Запросите доступ у инициатора или ответственного пользователя.",
    PAGE_NOT_FOUND:
      "Страница не найдена. Обновите страницу или проверьте, что ссылка еще актуальна.",
    SERVICE_UNAVAILABLE:
      "Сервис временно не отвечает. Обновите страницу. Если ошибка повторяется, обратитесь в поддержку.",
    FILE_UPLOAD_ERROR:
      "При загрузке файла возникла ошибка. Проверьте файл и попробуйте загрузить его еще раз.",
    FILE_TOO_LARGE:
      "Похоже, файл слишком большой. Уменьшите файл или попробуйте загрузить другой.",
    FILE_OPEN_ERROR:
      "Не удалось открыть или скачать файл. Обновите страницу и повторите действие.",
    NOTIFICATION_COUNTER_NOT_UPDATED:
      "Счетчик уведомлений не обновился. Обновите страницу, если счетчик не обновился - обратитесь в поддержку.",
  },
  en: {
    SESSION_EXPIRED:
      "It looks like your session has expired. Sign in again and repeat the action.",
    ACCESS_DENIED_SECTION:
      "It looks like you do not have access to this section. Contact an administrator if you need access.",
    ACCESS_DENIED_DOCUMENT:
      "It looks like you do not have access to this document. Ask the initiator or responsible user for access.",
    PAGE_NOT_FOUND:
      "The page was not found. Refresh the page or check that the link is still valid.",
    SERVICE_UNAVAILABLE:
      "The service is temporarily unavailable. Refresh the page. If the error repeats, contact support.",
    FILE_UPLOAD_ERROR:
      "There was an error while uploading the file. Check the file and try uploading it again.",
    FILE_TOO_LARGE:
      "The file seems to be too large. Reduce the file size or try uploading another file.",
    FILE_OPEN_ERROR:
      "Could not open or download the file. Refresh the page and try again.",
    NOTIFICATION_COUNTER_NOT_UPDATED:
      "The notification counter did not update. Refresh the page. If it still does not update, contact support.",
  },
};

const categoryDefinitions: CategoryDefinition[] = [
  {
    key: "documents",
    title: {
      kk: "Құжаттар",
      ru: "Документы",
      en: "Documents",
    },
    description: {
      kk: "Құру, іздеу, тарих және құжат қозғалысы",
      ru: "Создание, поиск, история и движение документов",
      en: "Creation, search, history, and document flow",
    },
    intents: ["DOCUMENT_HELP", "PROCESS_HELP"],
  },
  {
    key: "sign",
    title: {
      kk: "Қол қою",
      ru: "Подписание",
      en: "Signing",
    },
    description: {
      kk: "Қол қою, қолтаңба ақпараты және сыртқы қол қою",
      ru: "Подписание, информация о подписи и внешнее подписание",
      en: "Signing, signature information, and external signing",
    },
    intents: ["SIGN_HELP", "EXTERNAL_SIGN_HELP"],
  },
  {
    key: "access",
    title: {
      kk: "Қолжетімділік",
      ru: "Доступы",
      en: "Access",
    },
    description: {
      kk: "Құжаттарға, бөлімдерге және құқықтарға қолжетімділік",
      ru: "Доступ к документам, разделам и правам",
      en: "Access to documents, sections, and rights",
    },
    intents: ["ACCESS_HELP"],
  },
  {
    key: "nca",
    title: {
      kk: "NCALayer және ЭЦҚ",
      ru: "NCALayer и ЭЦП",
      en: "NCALayer and EDS",
    },
    description: {
      kk: "NCALayer, ЭЦҚ және сертификаттарды тексеру",
      ru: "Проверка NCALayer, ЭЦП и сертификатов",
      en: "Checking NCALayer, EDS, and certificates",
    },
    intents: ["NCA_HELP"],
  },
  {
    key: "notifications",
    title: {
      kk: "Хабарламалар",
      ru: "Уведомления",
      en: "Notifications",
    },
    description: {
      kk: "Хабарламалар және жаңа оқиғалар есептегіші",
      ru: "Уведомления и счетчик новых событий",
      en: "Notifications and new event counter",
    },
    intents: ["NOTIFICATION_HELP"],
  },
  {
    key: "profile",
    title: {
      kk: "Кіру және профиль",
      ru: "Вход и профиль",
      en: "Login and profile",
    },
    description: {
      kk: "Кіру, құпиясөз, профиль және құқықтарды беру",
      ru: "Вход, пароль, профиль и передача прав",
      en: "Login, password, profile, and delegation",
    },
    intents: ["AUTH_HELP", "PROFILE_HELP"],
  },
  {
    key: "files",
    title: {
      kk: "Файлдар",
      ru: "Файлы",
      en: "Files",
    },
    description: {
      kk: "Тіркемелерді жүктеу және ашу",
      ru: "Загрузка и открытие вложений",
      en: "Uploading and opening attachments",
    },
    intents: ["FILE_HELP"],
  },
  {
    key: "hr",
    title: {
      kk: "HR: қызметкерлер мен құжаттарды іздеу",
      ru: "HR: поиск сотрудников и документов",
      en: "HR: employee and document search",
    },
    description: {
      kk: "Қызметкерлерді және олардың қолжетімді құжаттарын іздеу",
      ru: "Поиск сотрудников и доступных документов",
      en: "Search for employees and accessible documents",
    },
    intents: ["HR_EMPLOYEE_SEARCH", "HR_DOCUMENT_SEARCH", "HR_HELP"],
  },
  {
    key: "reports",
    title: { kk: "Есептер", ru: "Отчёты", en: "Reports" },
    description: {
      kk: "Есептерді жасау және жүктеу",
      ru: "Формирование и выгрузка отчётов",
      en: "Generating and exporting reports",
    },
    intents: ["REPORT_HELP"],
  },
  {
    key: "support",
    title: { kk: "Қолдау", ru: "Поддержка", en: "Support" },
    description: {
      kk: "Өтініштер және қолдау қызметінің жауаптары",
      ru: "Обращения и ответы службы поддержки",
      en: "Support tickets and replies",
    },
    intents: ["SUPPORT_HELP"],
  },
  {
    key: "admin",
    title: {
      kk: "Әкімшілендіру",
      ru: "Администрирование",
      en: "Administration",
    },
    description: {
      kk: "Пайдаланушылар, компаниялар, лауазымдар, рөлдер және жүйелік қателер",
      ru: "Пользователи, компании, должности, роли и системные ошибки",
      en: "Users, companies, jobs, roles, and system errors",
    },
    intents: ["ADMIN_HELP", "SYSTEM_HELP"],
  },
];

const pageSuggestionContexts: PageSuggestionContext[] = [
  {
    key: "dashboard",
    routeNames: ["Dashboard"],
    pathPrefixes: ["/dashboard"],
    suggestionCodes: [
      "DASHBOARD_STATS",
      "FIND_DOCUMENT",
      "MY_TASKS_SECTION_HELP",
      "NOTIFICATIONS",
      "CREATE_DOCUMENT",
    ],
    fallbackIntents: [],
    categoryKeys: ["documents", "sign", "hr", "notifications"],
  },
  {
    key: "document-form",
    routeNames: ["DocumentCreate"],
    suggestionCodes: [
      "CREATE_DOCUMENT",
      "DOCUMENT_TEMPLATE_MISSING",
      "FILE_UPLOAD_ERROR",
      "FILE_TOO_LARGE",
    ],
    fallbackIntents: [],
    categoryKeys: ["documents", "files", "access"],
  },
  {
    key: "document-edit",
    routeNames: ["DocumentEdit"],
    suggestionCodes: ["FILE_UPLOAD_ERROR", "FILE_TOO_LARGE"],
    fallbackIntents: [],
    categoryKeys: ["documents", "files", "access"],
  },
  {
    key: "document-batch",
    routeNames: ["DocumentBatchCreate"],
    suggestionCodes: ["DOCUMENT_BATCH", "FILE_UPLOAD_ERROR", "FILE_TOO_LARGE"],
    fallbackIntents: [],
    categoryKeys: ["documents", "files", "access"],
  },
  {
    key: "document-details",
    routeNames: ["DocumentDetails"],
    suggestionCodes: [
      "SIGN_DOCUMENT",
      "SIGN_BUTTON_MISSING",
      "DOCUMENT_HISTORY",
      "GRANT_DOCUMENT_ACCESS",
    ],
    fallbackIntents: [],
    categoryKeys: ["documents", "sign", "access", "files"],
  },
  {
    key: "document-list",
    routeNames: ["DocumentList"],
    exactPaths: ["/documents", "/documents/document"],
    suggestionCodes: [
      "FIND_DOCUMENT",
      "CREATE_DOCUMENT",
      "DOCUMENT_TEMPLATE_MISSING",
      "PROCESS_STUCK",
    ],
    fallbackIntents: [],
    categoryKeys: ["documents", "files", "access"],
  },
  {
    key: "templates",
    pathPrefixes: ["/documents/document-template"],
    suggestionCodes: [
      "TEMPLATES_SECTION",
      "TEMPLATE_EDIT",
      "DOCUMENT_TEMPLATE_MISSING",
    ],
    fallbackIntents: [],
    categoryKeys: ["admin", "documents", "access"],
  },
  {
    key: "categories",
    pathPrefixes: ["/documents/document-constructor"],
    suggestionCodes: [
      "CATEGORIES_SECTION",
      "NOMENCLATURE_SECTION",
      "PROCESSES_SECTION",
    ],
    fallbackIntents: [],
    categoryKeys: ["admin", "documents", "access"],
  },
  {
    key: "nomenclature",
    pathPrefixes: ["/documents/nomenclature"],
    suggestionCodes: ["NOMENCLATURE_SECTION", "CATEGORIES_SECTION"],
    fallbackIntents: [],
    categoryKeys: ["admin", "documents"],
  },
  {
    key: "process-settings",
    pathPrefixes: ["/documents/process-template"],
    suggestionCodes: [
      "PROCESSES_SECTION",
      "MY_TASKS_SECTION_HELP",
      "CATEGORIES_SECTION",
    ],
    fallbackIntents: [],
    categoryKeys: ["admin", "documents", "sign"],
  },
  {
    key: "document-structure",
    routeNames: ["DocumentStructure"],
    pathPrefixes: ["/document-structure"],
    suggestionCodes: [
      "DOCUMENT_FOLDERS",
      "FIND_DOCUMENT",
      "ACCESS_DENIED_SECTION",
      "PAGE_NOT_FOUND",
    ],
    fallbackIntents: [],
    categoryKeys: ["documents", "access", "admin"],
  },
  {
    key: "coordination",
    pathPrefixes: ["/entity-approval"],
    suggestionCodes: ["COORDINATION"],
    fallbackIntents: [],
    categoryKeys: ["documents", "admin", "access"],
  },
  {
    key: "delegation",
    routeNames: ["TransferAuthority"],
    suggestionCodes: ["TRANSFER_AUTHORITY", "DELEGATION_STATUS"],
    fallbackIntents: [],
    categoryKeys: ["profile", "access"],
  },
  {
    key: "support",
    routeNames: ["Helpdesk"],
    suggestionCodes: [
      "HELPDESK_REQUEST",
      "HELPDESK_HISTORY",
      "SERVICE_UNAVAILABLE",
    ],
    fallbackIntents: ["SUPPORT_HELP"],
    categoryKeys: ["support", "access"],
  },
  {
    key: "process-tasks",
    routeNames: ["ProcessUsersList", "ProcessUserDetails"],
    pathPrefixes: ["/documents/process-user"],
    suggestionCodes: [
      "MY_TASKS_SECTION_HELP",
      "TASK_FILTERS",
      "SIGN_DOCUMENT",
      "SIGN_BUTTON_MISSING",
      "RETURN_TO_REWORK",
      "PROCESS_STUCK",
    ],
    fallbackIntents: [],
    categoryKeys: ["documents", "sign", "notifications"],
  },
  {
    key: "hr-settings",
    pathPrefixes: ["/hr/settings"],
    suggestionCodes: ["HR_SETTINGS", "HR_EMPLOYEE_TYPES", "HR_CHAT_ACCESS"],
    fallbackIntents: [],
    categoryKeys: ["hr", "access"],
  },
  {
    key: "hr-audit",
    pathPrefixes: ["/hr/audit"],
    suggestionCodes: ["HR_AUDIT"],
    fallbackIntents: [],
    categoryKeys: ["hr"],
  },
  {
    key: "hr-form",
    routeNames: ["HrEmployeeCreate"],
    suggestionCodes: ["HR_ADD_EMPLOYEE", "HR_EMPLOYEE_TYPES"],
    fallbackIntents: [],
    categoryKeys: ["hr", "access"],
  },
  {
    key: "hr-edit",
    routeNames: ["HrEmployeeEdit"],
    suggestionCodes: ["HR_EDIT_STATUS", "HR_EMPLOYEE_TYPES"],
    fallbackIntents: [],
    categoryKeys: ["hr", "access"],
  },
  {
    key: "hr-personal-file",
    routeNames: ["HrEmployeeDetails"],
    suggestionCodes: [
      "HR_PERSONAL_FILE",
      "HR_COMPLETENESS",
      "HR_UNCLASSIFIED",
      "HR_MAIL_REQUEST",
      "HR_EXPIRY",
    ],
    fallbackIntents: [],
    categoryKeys: ["hr", "documents", "access"],
  },
  {
    key: "hr",
    routeNames: ["HrEmployeeList"],
    pathPrefixes: ["/hr"],
    suggestionCodes: [
      "HR_EMPLOYEE_SEARCH",
      "HR_DOCUMENT_SEARCH",
      "HR_OVERVIEW",
      "HR_SETTINGS",
      "HR_MAIL_REQUEST",
      "HR_CHAT_ACCESS",
    ],
    fallbackIntents: [],
    categoryKeys: ["hr", "documents", "access"],
  },
  {
    key: "profile",
    routeNames: ["Profile", "UploadEcp"],
    suggestionCodes: [
      "PASSWORD_UPDATE",
      "TRANSFER_AUTHORITY",
      "CERTIFICATE_EXPIRES",
    ],
    fallbackIntents: [],
    categoryKeys: ["profile", "nca", "access"],
  },
  {
    key: "notifications",
    routeNames: ["Notifications"],
    suggestionCodes: [
      "NOTIFICATIONS",
      "NOTIFICATION_DOCUMENT",
      "NOTIFICATION_COUNTER_NOT_UPDATED",
    ],
    fallbackIntents: ["NOTIFICATION_HELP"],
    categoryKeys: ["notifications", "documents", "sign"],
  },
  {
    key: "external-sign",
    routeNames: ["ExternalSign"],
    suggestionCodes: [
      "EXTERNAL_SIGN_USER_FAILED",
      "EXTERNAL_SIGN_LINK",
      "NCA_UNAVAILABLE",
      "CERTIFICATE_EXPIRES",
    ],
    fallbackIntents: [],
    categoryKeys: ["sign", "nca", "files"],
  },
  {
    key: "admin-users",
    routeNames: ["UserList", "UserCreate", "UserDetails", "UserEdit"],
    pathPrefixes: ["/users"],
    suggestionCodes: ["USERS_SECTION_HELP", "USER_STATUS", "USER_ROLES"],
    fallbackIntents: [],
    categoryKeys: ["admin", "access", "profile"],
  },
  {
    key: "admin-roles",
    pathPrefixes: ["/roles"],
    suggestionCodes: ["ROLES_SECTION_HELP"],
    fallbackIntents: [],
    categoryKeys: ["admin", "access"],
  },
  {
    key: "admin-companies",
    routeNames: [
      "CompanyList",
      "CompanyCreate",
      "CompanyDetails",
      "CompanyEdit",
    ],
    pathPrefixes: ["/companies"],
    suggestionCodes: ["COMPANIES_SECTION_HELP", "COMPANY_STRUCTURE"],
    fallbackIntents: [],
    categoryKeys: ["admin", "access"],
  },
  {
    key: "admin-jobs",
    pathPrefixes: ["/jobs"],
    suggestionCodes: ["JOBS_SECTION_HELP"],
    fallbackIntents: [],
    categoryKeys: ["admin", "access"],
  },
  {
    key: "logs",
    routeNames: ["Logs"],
    pathPrefixes: ["/logs"],
    suggestionCodes: ["LOG_FILTERS", "LOG_EXPORT", "LOGS"],
    fallbackIntents: [],
    categoryKeys: ["admin", "access"],
  },
  {
    key: "reports",
    routeNames: ["reports"],
    pathPrefixes: ["/reports"],
    suggestionCodes: ["REPORTS", "REPORT_EXPORT"],
    fallbackIntents: ["REPORT_HELP"],
    categoryKeys: ["reports", "documents", "access"],
  },
];

const route = useRoute();
const router = useRouter();
const store = useStore();
const canSearchHrEmployees = computed(
  () =>
    store.getters[AuthGetters.GET_USER_IDENTITY]?.permissions?.includes(
      "HR_ASSISTANT_EMPLOYEE_SEARCH"
    ) === true
);
const canSearchHrDocuments = computed(
  () =>
    store.getters[AuthGetters.GET_USER_IDENTITY]?.permissions?.includes(
      "HR_ASSISTANT_DOCUMENT_SEARCH"
    ) === true
);
let conversationGeneration = 0;

const isOpen = ref(consumeAssistantAutoOpen());
const mobileSuggestionsOpen = ref(false);
const desktopSuggestionsOpen = ref(true);
const isMobileViewport = ref(false);
const assistantViewport = ref<{
  width: number;
  height: number;
  top: number;
  left: number;
} | null>(null);
const isCompactViewport = computed(
  () => assistantViewport.value !== null && assistantViewport.value.height < 480
);
const assistantViewportStyle = computed<Record<string, string>>(() => {
  const viewport = assistantViewport.value;
  return viewport
    ? {
        "--assistant-viewport-width": `${viewport.width}px`,
        "--assistant-viewport-height": `${viewport.height}px`,
        "--assistant-viewport-top": `${viewport.top}px`,
        "--assistant-viewport-left": `${viewport.left}px`,
      }
    : {};
});
const isLoading = ref(false);
const isBootstrapLoading = ref(false);
const selectedLanguage = ref<AssistantLanguage | null>(readStoredLanguage());
const selectedCategoryKey = ref<string | null>(null);
const menuView = ref<AssistantMenuView>("page");
const categoryParentView = ref<AssistantMenuView>("page");
const inputText = ref("");
const messageInput = ref<HTMLTextAreaElement | null>(null);
const hrEmployeeContextId = ref<string | null>(null);
const lastHrQuery = ref<string | null>(null);
const hrEmployeeSearch = ref(false);
const hrDocumentSearch = ref(false);
const hrUnclassifiedSearch = ref(false);
const canSearchUnclassifiedDocuments = ref(false);
const hrDocumentContinuation = ref<HrDocumentContinuation | null>(null);
const bootstrap = ref<AssistantBootstrapResponse | null>(null);
const bootstrapError = ref("");
const ncaStatus = ref<NcaStatus>("UNKNOWN");
const messagesContainer = ref<HTMLElement | null>(null);
const controlsContainer = ref<HTMLElement | null>(null);
const followLatestMessage = ref(true);
const messages = ref<ChatMessage[]>([]);
const hasConversation = computed(
  () => messages.value.length > 0 || isLoading.value
);
const suggestionsOpen = computed(() =>
  isMobileViewport.value
    ? !hasConversation.value || mobileSuggestionsOpen.value
    : desktopSuggestionsOpen.value
);
const lastErrorCode = ref<AssistantErrorCode | null>(null);
const lastErrorEventKey = ref("");
const lastErrorEventAt = ref(0);
const hasUnreadErrorHint = ref(false);
const supportFormOpen = ref(false);
const supportSubmitting = ref(false);
const supportError = ref("");
const supportFiles = ref<File[]>([]);
const assistantAvatarUrl = ref("");
const supportDescriptionInput = ref<HTMLTextAreaElement | null>(null);
const supportForm = ref<SupportForm>({
  subject: "",
  description: "",
  category: "QUESTION",
  includeTechnicalContext: false,
});

const currentLanguage = computed<AssistantLanguage>(() => {
  return selectedLanguage.value ?? "ru";
});

const uiText = computed(() => assistantTexts[currentLanguage.value]);
const supportUiText = computed(() => supportTexts[currentLanguage.value]);
const supportCategoryOptions = computed(() =>
  (Object.keys(supportUiText.value.categories) as TicketCategory[]).map(
    (value) => ({
      value,
      label: supportUiText.value.categories[value],
    })
  )
);
const canSubmitSupportTicket = computed(
  () =>
    Boolean(supportForm.value.subject.trim()) &&
    Boolean(supportForm.value.description.trim()) &&
    !supportSubmitting.value
);

const suggestions = computed<AssistantSuggestion[]>(() => {
  if (!selectedLanguage.value) {
    return [];
  }
  return (bootstrap.value?.suggestions ?? []).filter(
    (suggestion) =>
      (suggestion.intent !== "HR_EMPLOYEE_SEARCH" ||
        canSearchHrEmployees.value) &&
      (suggestion.intent !== "HR_DOCUMENT_SEARCH" || canSearchHrDocuments.value)
  );
});

const currentPageContext = computed<PageSuggestionContext | null>(() => {
  return (
    pageSuggestionContexts.find((context) =>
      isContextForCurrentRoute(context)
    ) ?? null
  );
});

const allContextualSuggestions = computed<AssistantSuggestion[]>(() => {
  const context = currentPageContext.value;
  if (!context) {
    return [];
  }

  return pickContextualSuggestions(context);
});

const contextualSuggestions = computed<AssistantSuggestion[]>(() => {
  return allContextualSuggestions.value.slice(0, MAX_CONTEXTUAL_SUGGESTIONS);
});

const allSuggestionCategories = computed<SuggestionCategory[]>(() => {
  const language = currentLanguage.value;
  const categories = categoryDefinitions.map((category) => ({
    key: category.key,
    title: category.title[language],
    description: category.description[language],
    intents: category.intents,
    items: [] as AssistantSuggestion[],
  }));

  suggestions.value.forEach((suggestion) => {
    const category = categories.find((item) =>
      item.intents.includes(suggestion.intent)
    );
    if (category) {
      addUniqueSuggestion(category.items, suggestion);
    }
  });

  const hr = categories.find((category) => category.key === "hr");
  if (hr) {
    const order: Record<string, number> = { HR_EMPLOYEE_SEARCH: 0, HR_DOCUMENT_SEARCH: 1 };
    hr.items.sort((left, right) => (order[left.intent] ?? 2) - (order[right.intent] ?? 2));
  }
  return categories.filter((category) => category.items.length > 0);
});

const relatedSuggestionCategories = computed<SuggestionCategory[]>(() => {
  const context = currentPageContext.value;
  if (!context) {
    return [];
  }

  return context.categoryKeys
    .map((categoryKey) =>
      allSuggestionCategories.value.find(
        (category) => category.key === categoryKey
      )
    )
    .filter((category): category is SuggestionCategory => Boolean(category))
    .slice(0, 4);
});

const selectedCategory = computed<SuggestionCategory | null>(() => {
  if (!selectedCategoryKey.value) {
    return null;
  }
  return (
    allSuggestionCategories.value.find(
      (category) => category.key === selectedCategoryKey.value
    ) ?? null
  );
});

const hasAssistantSuggestions = computed(() => {
  return (
    allContextualSuggestions.value.length > 0 ||
    allSuggestionCategories.value.length > 0
  );
});

const hasMorePageQuestions = computed(() => {
  return (
    allContextualSuggestions.value.length > contextualSuggestions.value.length
  );
});

const hasMoreTopics = computed(() => {
  return (
    allSuggestionCategories.value.length >
    relatedSuggestionCategories.value.length
  );
});

const ncaStatusText = computed(() => {
  if (ncaStatus.value === "CHECKING") {
    return uiText.value.ncaChecking;
  }
  if (ncaStatus.value === "AVAILABLE") {
    return uiText.value.ncaAvailable;
  }
  if (ncaStatus.value === "UNAVAILABLE") {
    return uiText.value.ncaUnavailable;
  }
  return "";
});

onMounted(() => {
  updateAssistantViewport();
  window.addEventListener("resize", updateAssistantViewport);
  window.visualViewport?.addEventListener("resize", updateAssistantViewport);
  window.visualViewport?.addEventListener("scroll", updateAssistantViewport);
  window.addEventListener(
    ASSISTANT_ERROR_EVENT_NAME,
    handleAssistantErrorEvent
  );
  window.addEventListener(
    ASSISTANT_AVATAR_UPDATED_EVENT,
    handleAssistantAvatarUpdated
  );
  void loadAssistantAvatar();
  if (isOpen.value && selectedLanguage.value) {
    void loadBootstrap();
  }
});

watch(isOpen, (open) => {
  if (open) updateAssistantViewport();
});

watch(
  () => [route.name, route.path],
  () => {
    resetMenuForCurrentPage();
  }
);

watch(
  () => [selectedCategoryKey.value, menuView.value],
  () => {
    void scrollControlsToTop();
  }
);

watch(
  () => accountKey(store.getters[AuthGetters.GET_USER_IDENTITY]),
  () => {
    conversationGeneration++;
    resetHrSearch();
    messages.value = [];
    mobileSuggestionsOpen.value = false;
    desktopSuggestionsOpen.value = true;
    followLatestMessage.value = true;
    inputText.value = "";
    bootstrap.value = null;
    bootstrapError.value = "";
    isLoading.value = false;
    isBootstrapLoading.value = false;
    lastErrorCode.value = null;
    supportFormOpen.value = false;
    clearAssistantAvatar();
    resetMenuForCurrentPage();
    if (isOpen.value && selectedLanguage.value) void loadBootstrap();
  },
  { flush: "sync" }
);

onBeforeUnmount(() => {
  conversationGeneration++;
  window.removeEventListener("resize", updateAssistantViewport);
  window.visualViewport?.removeEventListener("resize", updateAssistantViewport);
  window.visualViewport?.removeEventListener("scroll", updateAssistantViewport);
  window.removeEventListener(
    ASSISTANT_ERROR_EVENT_NAME,
    handleAssistantErrorEvent
  );
  window.removeEventListener(
    ASSISTANT_AVATAR_UPDATED_EVENT,
    handleAssistantAvatarUpdated
  );
  clearAssistantAvatar();
});

function updateAssistantViewport() {
  if (!isOpen.value || typeof window === "undefined") return;
  isMobileViewport.value = window.matchMedia(
    "(max-width: 768px), (hover: none) and (pointer: coarse)"
  ).matches;
  const viewport = window.visualViewport;
  const previous = assistantViewport.value;
  assistantViewport.value = {
    width: viewport?.width ?? window.innerWidth,
    height: viewport?.height ?? window.innerHeight,
    top: viewport?.offsetTop ?? 0,
    left: viewport?.offsetLeft ?? 0,
  };
  if (
    hasConversation.value &&
    previous &&
    (previous.width !== assistantViewport.value.width ||
      previous.height !== assistantViewport.value.height)
  ) {
    void scrollToBottom();
  }
}

function toggleSuggestions() {
  if (isMobileViewport.value) {
    mobileSuggestionsOpen.value = !mobileSuggestionsOpen.value;
    if (mobileSuggestionsOpen.value) {
      messageInput.value?.blur();
      void scrollControlsToTop();
    }
  } else {
    desktopSuggestionsOpen.value = !desktopSuggestionsOpen.value;
  }
  void scrollToBottom();
}

function handleInputEnter(event: KeyboardEvent) {
  if (event.isComposing) return;
  event.preventDefault();
  void sendMessage();
}
function handleAssistantAvatarUpdated() {
  void loadAssistantAvatar();
}

async function loadAssistantAvatar() {
  const generation = conversationGeneration;
  try {
    const response = await HelpdeskDataService.getAssistantAvatar();
    const avatar = response.data;
    if (generation !== conversationGeneration) return;
    if (!(avatar instanceof Blob) || !avatar.size || !avatar.type.startsWith("image/")) {
      clearAssistantAvatar();
      return;
    }
    const nextUrl = URL.createObjectURL(avatar);
    clearAssistantAvatar();
    assistantAvatarUrl.value = nextUrl;
  } catch (_) {
    if (generation === conversationGeneration) clearAssistantAvatar();
  }
}

function clearAssistantAvatar() {
  if (assistantAvatarUrl.value) {
    URL.revokeObjectURL(assistantAvatarUrl.value);
    assistantAvatarUrl.value = "";
  }
}

function handleAssistantErrorEvent(event: Event) {
  const detail = (event as CustomEvent<AssistantErrorEventDetail>).detail;
  if (!detail || !isAssistantErrorCode(detail.code)) {
    return;
  }

  const eventKey = `${detail.code}:${detail.source}:${getSafeRoutePath()}`;
  const now = Date.now();
  if (
    lastErrorEventKey.value === eventKey &&
    now - lastErrorEventAt.value < ERROR_EVENT_DEDUPE_MS
  ) {
    return;
  }

  lastErrorEventKey.value = eventKey;
  lastErrorEventAt.value = now;
  lastErrorCode.value = detail.code;

  void saveClientEvent(detail.code, detail.source);

  if (!selectedLanguage.value) {
    return;
  }

  addMessage({
    sender: "assistant",
    text: getAssistantErrorHint(detail.code),
    actions: [],
    feedback: null,
  });

  if (!isOpen.value) {
    hasUnreadErrorHint.value = true;
  }
}

function isContextForCurrentRoute(context: PageSuggestionContext): boolean {
  const routeName = route.name ? String(route.name) : "";
  const routePath = route.path || "";

  if (context.routeNames?.includes(routeName)) {
    if (!context.exactPaths?.length && !context.pathPrefixes?.length) {
      return true;
    }
  }

  if (context.exactPaths?.includes(routePath)) {
    return true;
  }

  return (
    context.pathPrefixes?.some(
      (pathPrefix) =>
        routePath === pathPrefix || routePath.startsWith(`${pathPrefix}/`)
    ) ?? false
  );
}

function pickContextualSuggestions(
  context: PageSuggestionContext
): AssistantSuggestion[] {
  const result: AssistantSuggestion[] = [];

  context.suggestionCodes.forEach((code) => {
    const suggestion = suggestions.value.find(
      (item) => normalizeSuggestionCode(item.code) === code
    );
    addUniqueSuggestion(result, suggestion);
  });

  suggestions.value.forEach((suggestion) => {
    if (context.fallbackIntents.includes(suggestion.intent)) {
      addUniqueSuggestion(result, suggestion);
    }
  });

  return result;
}

function addUniqueSuggestion(
  result: AssistantSuggestion[],
  suggestion?: AssistantSuggestion
) {
  if (!suggestion) {
    return;
  }

  const suggestionKey = getSuggestionKey(suggestion);
  if (result.some((item) => getSuggestionKey(item) === suggestionKey)) {
    return;
  }

  result.push(suggestion);
}

function getSuggestionKey(suggestion: AssistantSuggestion): string {
  return suggestion.title.trim().toLocaleLowerCase();
}

function normalizeSuggestionCode(value?: string | null): string {
  return (value || "").trim().toUpperCase();
}

function getAssistantErrorHint(code: AssistantErrorCode): string {
  return assistantErrorHints[currentLanguage.value][code];
}

function getLastErrorCodeForMessage(): string | null {
  if (
    lastErrorCode.value &&
    Date.now() - lastErrorEventAt.value <= ERROR_CONTEXT_TTL_MS
  ) {
    return lastErrorCode.value;
  }
  if (ncaStatus.value === "UNAVAILABLE") {
    return "NCA_UNAVAILABLE";
  }
  return null;
}

function openCategory(categoryKey: string, parentView: AssistantMenuView) {
  selectedCategoryKey.value = categoryKey;
  categoryParentView.value = currentPageContext.value ? parentView : "page";
}

function goBackInMenu() {
  if (selectedCategoryKey.value) {
    selectedCategoryKey.value = null;
    menuView.value = categoryParentView.value;
    return;
  }

  menuView.value = "page";
}

function resetMenuForCurrentPage() {
  selectedCategoryKey.value = null;
  menuView.value = "page";
  categoryParentView.value = "page";
  void scrollControlsToTop();
}

async function toggleAssistant() {
  isOpen.value = !isOpen.value;
  if (isOpen.value) {
    hasUnreadErrorHint.value = false;
  }
  if (isOpen.value && selectedLanguage.value) {
    await loadBootstrap();
    await scrollToBottom(true);
  }
}

async function loadBootstrap() {
  if (!selectedLanguage.value || bootstrap.value || isBootstrapLoading.value) {
    return;
  }

  isBootstrapLoading.value = true;
  const generation = conversationGeneration;
  bootstrapError.value = "";
  try {
    const response = await AssistantDataService.bootstrap(
      selectedLanguage.value
    );
    if (generation === conversationGeneration)
      bootstrap.value = response.data.data;
  } catch (error) {
    if (generation === conversationGeneration)
      bootstrapError.value = uiText.value.bootstrapError;
  } finally {
    if (generation === conversationGeneration) isBootstrapLoading.value = false;
  }
}

function resetHrSearch() {
  lastHrQuery.value = null;
  hrDocumentContinuation.value = null;
  hrEmployeeContextId.value = null;
  hrEmployeeSearch.value = false;
  hrDocumentSearch.value = false;
  hrUnclassifiedSearch.value = false;
  canSearchUnclassifiedDocuments.value = false;
}

async function sendSuggestion(suggestion: AssistantSuggestion) {
  if (isLoading.value || !selectedLanguage.value) return;
  if (
    (suggestion.intent === "HR_EMPLOYEE_SEARCH" &&
      !canSearchHrEmployees.value) ||
    (suggestion.intent === "HR_DOCUMENT_SEARCH" && !canSearchHrDocuments.value)
  ) {
    return;
  }
  resetHrSearch();
  hrEmployeeSearch.value =
    suggestion.intent === "HR_EMPLOYEE_SEARCH" ||
    (suggestion.intent === "HR_DOCUMENT_SEARCH" && canSearchHrEmployees.value);
  hrDocumentSearch.value =
    suggestion.intent === "HR_DOCUMENT_SEARCH" && !hrEmployeeSearch.value;
  await sendMessage(suggestion.title);
}

function startEmployeeSearch() {
  if (isLoading.value) return;
  resetHrSearch();
  hrEmployeeSearch.value = true;
  inputText.value = "";
  followLatestMessage.value = true;
  addMessage({
    sender: "assistant",
    text: hrAssistantTexts[currentLanguage.value].employeeSearchHint,
  });
}

function promptDocumentSearch() {
  if (isLoading.value) return;
  hrDocumentContinuation.value = null;
  inputText.value = "";
  addMessage({
    sender: "assistant",
    text: hrAssistantTexts[currentLanguage.value].documentSearchHint,
  });
}

function finishHrSearch() {
  if (isLoading.value) return;
  resetHrSearch();
  inputText.value = "";
  resetMenuForCurrentPage();
  addMessage({
    sender: "assistant",
    text: hrAssistantTexts[currentLanguage.value].searchFinished,
  });
}

async function loadMoreDocuments(messageId: string) {
  const continuation = hrDocumentContinuation.value;
  if (
    !continuation ||
    continuation.messageId !== messageId ||
    isLoading.value ||
    continuation.employeeId !== hrEmployeeContextId.value ||
    continuation.unclassified !== hrUnclassifiedSearch.value
  )
    return;
  await sendMessage(continuation.query, continuation);
}

async function toggleUnclassifiedDocuments() {
  if (
    isLoading.value ||
    !hrEmployeeContextId.value ||
    (!hrUnclassifiedSearch.value && !canSearchUnclassifiedDocuments.value)
  )
    return;
  if (hrUnclassifiedSearch.value) {
    await showAllEmployeeDocuments();
    return;
  }
  hrUnclassifiedSearch.value = true;
  hrDocumentContinuation.value = null;
  await sendMessage(hrAssistantTexts[currentLanguage.value].showUnclassified);
}

async function showAllEmployeeDocuments() {
  if (
    isLoading.value ||
    !selectedLanguage.value ||
    !hrEmployeeContextId.value ||
    !canSearchHrDocuments.value
  )
    return;
  hrEmployeeSearch.value = false;
  hrDocumentSearch.value = true;
  hrUnclassifiedSearch.value = false;
  hrDocumentContinuation.value = null;
  await sendMessage(
    hrAssistantTexts[currentLanguage.value].showEmployeeDocuments
  );
}
async function sendMessage(
  predefinedText?: string,
  continuation?: HrDocumentContinuation
) {
  if (!selectedLanguage.value) {
    return;
  }

  const rawMessage = (predefinedText ?? inputText.value).trim();
  if (!rawMessage || isLoading.value) {
    return;
  }

  const visibleMessage = truncateText(rawMessage, 500);
  const outgoingMessage = sanitizeOutgoingText(visibleMessage);
  const refersToPrevious = /из них|из этого списка|из найденных|среди найденных|среди них|оставь только|а теперь только|теперь только|among (?:those|them)|from (?:those|that list)|олардың ішінен/iu.test(outgoingMessage);
  const previousQuery = continuation ? continuation.previousQuery : refersToPrevious ? lastHrQuery.value : null;
  const employeeId = continuation
    ? continuation.employeeId
    : hrEmployeeContextId.value;
  if (!continuation) hrDocumentContinuation.value = null;
  mobileSuggestionsOpen.value = false;
  inputText.value = "";
  followLatestMessage.value = true;
  addMessage({
    sender: "user",
    text: continuation
      ? hrAssistantTexts[currentLanguage.value].showMore
      : visibleMessage,
  });

  isLoading.value = true;
  const generation = conversationGeneration;
  try {
    const response = await AssistantDataService.message({
      message: outgoingMessage,
      routeName: getCurrentRouteName(),
      routePath: getMessageRoutePath(),
      lastErrorCode: getLastErrorCodeForMessage(),
      ncaStatus: ncaStatus.value === "UNKNOWN" ? null : ncaStatus.value,
      language: selectedLanguage.value,
      hrEmployeeContextId: employeeId,
      hrPreviousQuery: previousQuery,
      hrEmployeeSearch: continuation ? false : hrEmployeeSearch.value,
      hrDocumentSearch: continuation ? true : hrDocumentSearch.value,
      hrUnclassifiedDocuments: continuation
        ? continuation.unclassified
        : hrUnclassifiedSearch.value,
      hrDocumentPage: continuation?.page ?? 0,
    });

    if (generation === conversationGeneration) {
      hrDocumentContinuation.value = null;
      const data = response.data.data;
      const messageId = addAssistantResponse(data);
      if (data.source === "HR" && data.intent.startsWith("HR_QUERY_")
          && !["HR_QUERY_CLARIFY", "HR_QUERY_UNAVAILABLE", "HR_QUERY_BATCH"].includes(data.intent)) {
        const combinedQuery = refersToPrevious && previousQuery
          ? `${previousQuery}; ${outgoingMessage}` : outgoingMessage;
        // Never silently truncate conditions from the previous query.
        lastHrQuery.value = combinedQuery.length <= 500 ? combinedQuery : null;
      }
      const page = data.documentPage;
      if (
        data.source === "HR" &&
        data.hasMoreDocuments &&
        [
          "HR_DOCUMENT_SEARCH",
          "HR_DOCUMENT_EXPIRING",
          "HR_DOCUMENT_EXPIRED",
          "HR_DOCUMENT_UNCLASSIFIED",
          "HR_CATEGORY_DOCUMENT_SEARCH",
          "HR_QUERY_DOCUMENTS",
          "HR_QUERY_EMPLOYEES",
          "HR_QUERY_BATCH",
        ].includes(data.intent) &&
        typeof page === "number" &&
        Number.isInteger(page) &&
        page === (continuation?.page ?? 0) &&
        page < 10000 &&
        (data.resultCount ?? 0) > 0
      ) {
        hrDocumentContinuation.value = {
          messageId,
          query: outgoingMessage,
          employeeId: data.hrEmployeeContextId || (data.intent.startsWith("HR_QUERY_") ? null : employeeId),
          page: page + 1,
          unclassified: hrUnclassifiedSearch.value,
          previousQuery,
        };
      }
      lastErrorCode.value = null;
    }
  } catch (error) {
    if (generation === conversationGeneration)
      addMessage({
      sender: "system",
      text: uiText.value.answerError,
    });
  } finally {
    if (generation === conversationGeneration) {
      isLoading.value = false;
      await scrollToBottom();
    }
  }
}

function addAssistantResponse(response: AssistantMessageResponse) {
  if (response.source === "HR") {
    canSearchUnclassifiedDocuments.value =
      response.canSearchUnclassifiedDocuments === true;
    if (response.intent === "HR_DOCUMENT_UNCLASSIFIED") {
      hrUnclassifiedSearch.value = true;
    } else if (
      [
        "HR_DOCUMENT_SEARCH",
        "HR_DOCUMENT_EXPIRING",
        "HR_DOCUMENT_EXPIRED",
        "HR_CATEGORY_DOCUMENT_SEARCH",
        "HR_QUERY_DOCUMENTS",
      ].includes(response.intent)
    ) {
      hrUnclassifiedSearch.value = false;
    }
    if (response.intent === "HR_CONTEXT_UNAVAILABLE") {
      resetHrSearch();
    } else if (response.intent.startsWith("HR_QUERY_") && response.intent !== "HR_QUERY_CLARIFY"
      && response.intent !== "HR_QUERY_UNAVAILABLE") {
      resetHrSearch();
      hrEmployeeContextId.value = response.hrEmployeeContextId || null;
      hrEmployeeSearch.value = response.intent === "HR_QUERY_EMPLOYEES";
      hrDocumentSearch.value = response.intent === "HR_QUERY_DOCUMENTS" || !!response.hrEmployeeContextId;
    } else if (response.intent === "HR_EMPLOYEE_SEARCH") {
      resetHrSearch();
      hrEmployeeSearch.value = true;
    } else if (response.intent === "HR_CATEGORY_EMPLOYEE_CLARIFY") {
      hrEmployeeContextId.value = null;
      hrEmployeeSearch.value = false;
      hrDocumentSearch.value = true;
    } else if (
      response.hrEmployeeContextId ||
      response.intent.startsWith("HR_DOCUMENT_") ||
      response.intent.startsWith("HR_CATEGORY_")
    ) {
      hrEmployeeContextId.value =
        response.hrEmployeeContextId || hrEmployeeContextId.value;
      hrEmployeeSearch.value = false;
      hrDocumentSearch.value = true;
    }
  }
  return addMessage({
    sender: "assistant",
    text: response.answer,
    messageId: response.messageId,
    intent: response.intent,
    actions: response.actions ?? [],
    feedback: null,
  });
}

function addMessage(message: Omit<ChatMessage, "id">) {
  const entry = {
    id: makeLocalId(message.sender),
    ...message,
  };
  messages.value.push(entry);
  scrollToBottom();
  return entry.id;
}

async function selectLanguage(language: AssistantLanguage) {
  const previousLanguage = selectedLanguage.value;
  selectedLanguage.value = language;
  saveStoredLanguage(language);
  resetMenuForCurrentPage();
  bootstrap.value = null;
  bootstrapError.value = "";

  if (previousLanguage && hasConversation.value) {
    addMessage({
      sender: "assistant",
      text: assistantTexts[language].languageChanged,
      actions: [],
      feedback: null,
    });
  }

  await loadBootstrap();
  await scrollToBottom();
}

function documentActionTitle(action: AssistantAction): string {
  return (
    action.documentTypeName?.trim() ||
    action.fileName?.trim() ||
    action.label.replace(/^(?:Открыть|Ашу|Open):\s*/i, "")
  );
}

function documentActionFileName(action: AssistantAction): string {
  const name = action.fileName?.trim();
  return name && name !== documentActionTitle(action) ? name : "";
}

async function handleAction(action: AssistantAction) {
  if (isLoading.value) return;
  if (action.type === "ASSISTANT_QUERY") {
    await sendMessage(action.value);
    return;
  }

  if (action.type === "SELECT_HR_EMPLOYEE") {
    if (!/^[0-9A-Za-z]{16}$/.test(action.value)) {
      addMessage({ sender: "system", text: uiText.value.navigationBlocked });
      return;
    }
    hrEmployeeContextId.value = action.value;
    hrUnclassifiedSearch.value = false;
    canSearchUnclassifiedDocuments.value = false;
    hrEmployeeSearch.value = false;
    hrDocumentSearch.value = true;
    addMessage({
      sender: "assistant",
      text: `${hrAssistantTexts[currentLanguage.value].employeeSelected}: ${
        action.label
      }`,
      actions: [],
      feedback: null,
    });
    await sendMessage(
      hrAssistantTexts[currentLanguage.value].showEmployeeDocuments
    );
    return;
  }

  if (action.type === "DOWNLOAD_HR_DOCUMENT") {
    await downloadHrDocument(action.value);
    return;
  }

  if (action.type === "NAVIGATE") {
    await navigateToSafePath(action.value);
    return;
  }

  if (action.type === "CHECK_NCA") {
    if (action.value === "NCA_INSTRUCTION" || action.value === "NCA_DOWNLOAD") {
      openSafeUrl(resolveActionUrl(action.value));
      return;
    }
    await checkNcaLayer();
    return;
  }

  if (action.type === "OPEN_URL") {
    openSafeUrl(resolveActionUrl(action.value));
    return;
  }

  if (action.type === "CONTACT_SUPPORT") {
    openSupportForm();
  }
}

async function downloadHrDocument(value: string) {
  const match =
    /^([0-9A-Za-z]{16}):([0-9A-Za-z]{16}):(FILE|ESIGN_DOCUMENT)$/.exec(value);
  if (!match) {
    addMessage({
      sender: "system",
      text: hrAssistantTexts[currentLanguage.value].downloadError,
    });
    return;
  }
  if (isLoading.value) return;
  isLoading.value = true;
  const generation = conversationGeneration;
  try {
    const response = await HrDataService.downloadAssistantDocument(
      match[1],
      match[2]
    );
    if (generation !== conversationGeneration) return;
    const disposition = String(response.headers?.["content-disposition"] || "");
    const encoded = /filename\*=UTF-8''([^;]+)/i.exec(disposition)?.[1];
    const quoted = /filename="([^"]+)"/i.exec(disposition)?.[1];
    const filename = encoded
      ? decodeURIComponent(encoded)
      : quoted || "document";
    downloadBlob(response.data, filename);
  } catch {
    if (generation === conversationGeneration)
      addMessage({
        sender: "system",
        text: hrAssistantTexts[currentLanguage.value].downloadError,
      });
  } finally {
    if (generation === conversationGeneration) {
      isLoading.value = false;
      await scrollToBottom();
    }
  }
}

async function navigateToSafePath(value: string) {
  const path = normalizeInternalPath(value);
  if (!path) {
    addMessage({
      sender: "system",
      text: uiText.value.navigationBlocked,
    });
    return;
  }

  await router.push(path);
  await scrollToBottom();
}

async function checkNcaLayer() {
  ncaStatus.value = "CHECKING";
  const isAvailable = await checkNcaLayerConnection(3000);
  ncaStatus.value = isAvailable ? "AVAILABLE" : "UNAVAILABLE";

  await saveClientEvent(isAvailable ? "NCA_AVAILABLE" : "NCA_UNAVAILABLE");

  addMessage({
    sender: "assistant",
    text: isAvailable
      ? uiText.value.ncaAvailableMessage
      : uiText.value.ncaUnavailableMessage,
    actions: [],
    feedback: null,
  });
}

async function sendFeedback(message: ChatMessage, helpful: boolean) {
  if (!message.messageId || message.feedback !== null) {
    return;
  }

  try {
    await AssistantDataService.feedback({
      messageId: message.messageId,
      intent: message.intent ?? null,
      helpful,
    });
    message.feedback = helpful;
    if (!helpful) {
      openSupportForm(message.text);
    }
  } catch (error) {
    addMessage({
      sender: "system",
      text: uiText.value.feedbackError,
    });
  }
}

function openSupportForm(answerText = "") {
  const lastUserMessage = [...messages.value]
    .reverse()
    .find((message) => message.sender === "user")?.text;
  const description = lastUserMessage || answerText;

  supportForm.value = {
    subject: truncateText(lastUserMessage || answerText || supportUiText.value.title, 200),
    description: truncateText(description, 4000),
    category: inferSupportCategory(),
    includeTechnicalContext: false,
  };
  supportFiles.value = [];
  supportError.value = "";
  supportFormOpen.value = true;
  void nextTick(() => supportDescriptionInput.value?.focus());
}

function closeSupportForm() {
  if (supportSubmitting.value) {
    return;
  }
  supportFormOpen.value = false;
  supportFiles.value = [];
  supportError.value = "";
}

function inferSupportCategory(): TicketCategory {
  const errorCode = getLastErrorCodeForMessage();
  if (errorCode?.startsWith("ACCESS_")) {
    return "ACCESS";
  }
  if (errorCode?.startsWith("NCA_") || errorCode === "CERTIFICATE_EXPIRES") {
    return "NCALAYER";
  }
  if (errorCode || lastErrorCode.value) {
    return "BUG";
  }
  return "QUESTION";
}

function onSupportFilesSelected(event: Event) {
  const input = event.target as HTMLInputElement;
  const selectedFiles = Array.from(input.files || []);
  input.value = "";

  addSupportFiles(selectedFiles);
}

function addSupportFiles(selectedFiles: File[]) {
  if (!selectedFiles.length) return;
  const allowedTypes = new Set(["image/jpeg", "image/png"]);
  const maxFileSize = 10 * 1024 * 1024;
  if (
    selectedFiles.some(
      (file) => !allowedTypes.has(file.type) || file.size > maxFileSize
    )
  ) {
    supportError.value = supportUiText.value.fileError;
    return;
  }

  const uniqueFiles = [...supportFiles.value];
  selectedFiles.forEach((file) => {
    const duplicate = uniqueFiles.some(
      (current) =>
        current.name === file.name &&
        current.size === file.size &&
        current.lastModified === file.lastModified
    );
    if (!duplicate && uniqueFiles.length < 5) {
      uniqueFiles.push(file);
    }
  });
  supportFiles.value = uniqueFiles;
  supportError.value = "";
}

function onSupportPaste(event: ClipboardEvent) {
  const imageItems = Array.from(event.clipboardData?.items || []).filter(
    (item) => item.kind === "file" && ["image/jpeg", "image/png"].includes(item.type)
  );
  if (!imageItems.length) return;

  const timestamp = new Date();
  const datePart = [
    timestamp.getFullYear(),
    String(timestamp.getMonth() + 1).padStart(2, "0"),
    String(timestamp.getDate()).padStart(2, "0"),
  ].join("");
  const timePart = [
    String(timestamp.getHours()).padStart(2, "0"),
    String(timestamp.getMinutes()).padStart(2, "0"),
    String(timestamp.getSeconds()).padStart(2, "0"),
  ].join("");
  const files = imageItems.flatMap((item, index) => {
    const blob = item.getAsFile();
    if (!blob) return [];
    const extension = blob.type === "image/jpeg" ? "jpg" : "png";
    return [
      new File([blob], `screenshot-${datePart}-${timePart}-${index + 1}.${extension}`, {
          type: blob.type,
        lastModified: Date.now(),
        }
      ),
    ];
  });
  if (files.length) {
    event.preventDefault();
    addSupportFiles(files);
  }
}

function removeSupportFile(index: number) {
  supportFiles.value.splice(index, 1);
}

async function submitSupportTicket() {
  if (!selectedLanguage.value || !canSubmitSupportTicket.value) {
    supportError.value = supportUiText.value.required;
    return;
  }

  supportSubmitting.value = true;
  supportError.value = "";
  try {
    const errorCode = supportForm.value.includeTechnicalContext
      ? getLastErrorCodeForMessage()
      : null;
    const response = await HelpdeskDataService.create(
      {
        subject: sanitizeOutgoingText(
          truncateText(supportForm.value.subject.trim(), 200)
        ),
        description: sanitizeOutgoingText(
          truncateText(supportForm.value.description.trim(), 4000)
        ),
        category: supportForm.value.category,
        source: errorCode ? "SYSTEM_ERROR" : "ASSISTANT",
        language: selectedLanguage.value,
        routePath: supportForm.value.includeTechnicalContext
          ? getSafeRoutePath()
          : null,
        errorCode,
      },
      makeIdempotencyKey()
    );

    const ticket = response.data;
    const uploadResults = await Promise.all(
      supportFiles.value.map((file) =>
        HelpdeskDataService.uploadAttachment(ticket.id, file)
          .then(() => true)
          .catch(() => false)
      )
    );
    const hasUploadFailure = uploadResults.some((result) => !result);

    supportSubmitting.value = false;
    closeSupportForm();
    addMessage({
      sender: "assistant",
      text: `${supportUiText.value.created(ticket.ticketNumber)}${
        hasUploadFailure ? ` ${supportUiText.value.partialUpload}` : ""
      }`,
      actions: [
        {
          type: "NAVIGATE",
          label: supportUiText.value.openTicket,
          value: `/helpdesk?ticket=${encodeURIComponent(ticket.id)}`,
        },
      ],
      feedback: null,
    });
  } catch (error) {
    supportError.value = supportUiText.value.createError;
  } finally {
    supportSubmitting.value = false;
  }
}

async function openMyTickets() {
  await router.push({ name: "Helpdesk" });
}

function makeIdempotencyKey(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return makeLocalId("ticket");
}

async function saveClientEvent(eventCode: string, source = "ASSISTANT_WIDGET") {
  try {
    await AssistantDataService.event({
      eventCode,
      source,
      routeName: getCurrentRouteName(),
      routePath: getSafeRoutePath(),
    });
  } catch (error) {
    return;
  }
}

function resolveActionUrl(value: string): string | null {
  if (value === "NCA_INSTRUCTION") {
    return bootstrap.value?.ncaLayer?.instructionUrl || null;
  }
  if (value === "NCA_DOWNLOAD") {
    return bootstrap.value?.ncaLayer?.downloadUrl || null;
  }
  return value;
}

function openSafeUrl(value: string | null) {
  if (!value) {
    addMessage({
      sender: "system",
      text: uiText.value.urlMissing,
    });
    return;
  }

  try {
    const url = new URL(value);
    if (!["https:", "http:"].includes(url.protocol)) {
      throw new Error("Unsupported protocol");
    }
    window.open(url.toString(), "_blank", "noopener,noreferrer");
  } catch (error) {
    addMessage({
      sender: "system",
      text: uiText.value.urlUnsafe,
    });
  }
}

function normalizeInternalPath(value: string): string | null {
  const trimmed = value.trim();
  if (
    !trimmed.startsWith("/") ||
    trimmed.startsWith("//") ||
    trimmed.includes("\\") ||
    hasControlCharacters(trimmed)
  ) {
    return null;
  }
  return truncateText(trimmed, 255);
}

function hasControlCharacters(value: string): boolean {
  for (let index = 0; index < value.length; index += 1) {
    const code = value.charCodeAt(index);
    if (code >= 0 && code <= 31) {
      return true;
    }
  }
  return false;
}

function getCurrentRouteName(): string | null {
  if (!route.name) {
    return null;
  }
  return truncateText(String(route.name), 120);
}

function getSafeRoutePath(): string {
  const pathWithoutIds = route.path
    .replace(
      /\/public\/external-sign\/[^/]+(?=\/|$)/i,
      "/public/external-sign/:token"
    )
    .replace(/\/\d+(?=\/|$)/g, "/:id")
    .replace(
      /\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?=\/|$)/gi,
      "/:id"
    )
    .replace(/\/[A-Za-z0-9_-]{24,}(?=\/|$)/g, "/:id");
  return truncateText(pathWithoutIds, 255);
}

function getMessageRoutePath(): string {
  const path = getSafeRoutePath();
  if (route.name !== "DocumentList") return path;
  const rawType = route.query?.type;
  const rawStatus = route.query?.status;
  const type = Array.isArray(rawType) ? rawType[0] : rawType;
  const status = Array.isArray(rawStatus) ? rawStatus[0] : rawStatus;
  const parameters: string[] = [];
  // Only public folder/status values are relevant; never send arbitrary search filters.
  if (
    ["ALL", "NEW", "TRACKING", "REWORK", "FAVORITE"].includes(type ?? "ALL")
  ) {
    parameters.push(`type=${type ?? "ALL"}`);
  }
  if (
    typeof status === "string" &&
    ["PROCESS", "SUCCESS", "DENIED"].includes(status)
  ) {
    parameters.push(`status=${status}`);
  }
  return parameters.length ? `${path}?${parameters.join("&")}` : path;
}

function sanitizeOutgoingText(value: string): string {
  return value
    .replace(
      /[A-Za-z0-9_-]{20,}\.[A-Za-z0-9_-]{20,}\.[A-Za-z0-9_-]{20,}/g,
      "[token]"
    )
    .replace(/\b\d{12}\b/g, "[iin]")
    .replace(/\b[A-Za-z0-9+/=]{80,}\b/g, "[data]")
    .replace(/((?:парол[ья]|password)\s*[:=]\s*)\S+/gi, "$1[hidden]");
}

function truncateText(value: string, maxLength: number): string {
  return value.length > maxLength ? value.slice(0, maxLength) : value;
}

function formatQuestionCount(count: number): string {
  if (currentLanguage.value === "kk") {
    return `${count} сұрақ`;
  }
  if (currentLanguage.value === "en") {
    return count === 1 ? "1 question" : `${count} questions`;
  }

  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;
  if (lastDigit === 1 && lastTwoDigits !== 11) {
    return `${count} вопрос`;
  }
  if (
    lastDigit >= 2 &&
    lastDigit <= 4 &&
    (lastTwoDigits < 12 || lastTwoDigits > 14)
  ) {
    return `${count} вопроса`;
  }
  return `${count} вопросов`;
}

function readStoredLanguage(): AssistantLanguage | null {
  try {
    const value = sessionStorage.getItem(LANGUAGE_STORAGE_KEY);
    return isSupportedLanguage(value) ? value : null;
  } catch (error) {
    return null;
  }
}

function saveStoredLanguage(language: AssistantLanguage) {
  try {
    sessionStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch (error) {
    return;
  }
}

function isSupportedLanguage(value: string | null): value is AssistantLanguage {
  return value === "kk" || value === "ru" || value === "en";
}

function makeLocalId(prefix: string): string {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

function handleHistoryScroll() {
  const container = messagesContainer.value;
  if (container) {
    followLatestMessage.value =
      container.scrollHeight - container.scrollTop - container.clientHeight <=
      32;
  }
}

async function scrollControlsToTop() {
  await nextTick();
  if (controlsContainer.value) controlsContainer.value.scrollTop = 0;
}

async function scrollToBottom(force = false) {
  await nextTick();
  if (force) followLatestMessage.value = true;
  if (messagesContainer.value && followLatestMessage.value) {
    messagesContainer.value.scrollTop = messagesContainer.value.scrollHeight;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["assistant-widget", {
      'assistant-widget--open': isOpen.value,
      'assistant-widget--compact': _unref(isCompactViewport),
    }]),
    style: _normalizeStyle(_unref(assistantViewportStyle))
  }, [
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("section", {
          key: 0,
          class: "assistant-panel",
          "aria-label": _unref(uiText).title
        }, [
          _createElementVNode("header", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (assistantAvatarUrl.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: assistantAvatarUrl.value,
                      alt: ""
                    }, null, 8, _hoisted_5))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, "AI"))
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(uiText).title), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(uiText).subtitle), 1)
              ])
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "assistant-icon-button",
              "aria-label": _unref(uiText).close,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = false))
            }, [
              _createVNode(_unref(XIcon), {
                class: "assistant-close-icon",
                "aria-hidden": "true"
              })
            ], 8, _hoisted_10)
          ]),
          (supportFormOpen.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "assistant-support-backdrop",
                onClick: _withModifiers(closeSupportForm, ["self"])
              }, [
                _createElementVNode("section", {
                  class: "assistant-support-dialog",
                  role: "dialog",
                  "aria-modal": "true",
                  "aria-label": _unref(supportUiText).title,
                  onPaste: onSupportPaste
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(supportUiText).title), 1),
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(supportUiText).subtitle), 1)
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "assistant-support-close",
                      "aria-label": _unref(uiText).close,
                      disabled: supportSubmitting.value,
                      onClick: closeSupportForm
                    }, [
                      _createVNode(_unref(XIcon), {
                        class: "assistant-close-icon",
                        "aria-hidden": "true"
                      })
                    ], 8, _hoisted_16)
                  ]),
                  _createElementVNode("label", _hoisted_17, [
                    _createElementVNode("span", null, _toDisplayString(_unref(supportUiText).subject), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((supportForm.value.subject) = $event)),
                      maxlength: "200"
                    }, null, 512), [
                      [
                        _vModelText,
                        supportForm.value.subject,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_18, [
                    _createElementVNode("span", null, _toDisplayString(_unref(supportUiText).category), 1),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((supportForm.value.category) = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(supportCategoryOptions), (option) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: option.value,
                          value: option.value
                        }, _toDisplayString(option.label), 9, _hoisted_19))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, supportForm.value.category]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_20, [
                    _createElementVNode("span", null, _toDisplayString(_unref(supportUiText).description), 1),
                    _withDirectives(_createElementVNode("textarea", {
                      ref: (_value, _refs) => {
                        _refs['supportDescriptionInput'] = _value
                        supportDescriptionInput.value = _value
                      },
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((supportForm.value.description) = $event)),
                      maxlength: "4000",
                      rows: "5"
                    }, null, 512), [
                      [
                        _vModelText,
                        supportForm.value.description,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_21, [
                    _createElementVNode("span", null, _toDisplayString(_unref(supportUiText).attachments), 1),
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/jpeg,image/png",
                      multiple: "",
                      disabled: supportSubmitting.value,
                      onChange: onSupportFilesSelected
                    }, null, 40, _hoisted_22),
                    _createElementVNode("small", null, _toDisplayString(_unref(supportUiText).attachmentsHint), 1)
                  ]),
                  (supportFiles.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supportFiles.value, (file, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `${file.name}-${file.size}-${file.lastModified}`,
                            class: "assistant-support-file-row"
                          }, [
                            _createElementVNode("span", null, _toDisplayString(file.name), 1),
                            _createElementVNode("button", {
                              type: "button",
                              disabled: supportSubmitting.value,
                              onClick: ($event: any) => (removeSupportFile(index))
                            }, _toDisplayString(_unref(supportUiText).remove), 9, _hoisted_24)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("label", _hoisted_25, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((supportForm.value.includeTechnicalContext) = $event)),
                      type: "checkbox"
                    }, null, 512), [
                      [_vModelCheckbox, supportForm.value.includeTechnicalContext]
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_unref(supportUiText).includeContext), 1)
                  ]),
                  (supportError.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(supportError.value), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "assistant-secondary-button",
                      disabled: supportSubmitting.value,
                      onClick: closeSupportForm
                    }, _toDisplayString(_unref(supportUiText).cancel), 9, _hoisted_28),
                    _createElementVNode("button", {
                      type: "button",
                      class: "assistant-send",
                      disabled: !_unref(canSubmitSupportTicket),
                      onClick: submitSupportTicket
                    }, _toDisplayString(supportSubmitting.value ? _unref(supportUiText).sending : _unref(supportUiText).submit), 9, _hoisted_29)
                  ])
                ], 40, _hoisted_12)
              ], 8, _hoisted_11))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["assistant-body", {
          'assistant-body--intro': !_unref(hasConversation),
          'assistant-body--menu-open': _unref(suggestionsOpen),
        }])
          }, [
            (selectedLanguage.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "assistant-menu-toggle",
                  "aria-expanded": _unref(suggestionsOpen),
                  "aria-controls": "assistant-suggestions",
                  onClick: toggleSuggestions
                }, [
                  _createTextVNode(_toDisplayString(_unref(uiText).readyQuestions) + " ", 1),
                  _createVNode(_unref(ChevronRightIcon), {
                    class: _normalizeClass(["assistant-menu-toggle-icon", {
              'assistant-menu-toggle-icon--open': _unref(suggestionsOpen),
            }]),
                    "aria-hidden": "true"
                  }, null, 8, ["class"])
                ], 8, _hoisted_30))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              id: "assistant-suggestions",
              ref: (_value, _refs) => {
                _refs['controlsContainer'] = _value
                controlsContainer.value = _value
              },
              class: "assistant-controls"
            }, [
              (!selectedLanguage.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("div", _hoisted_33, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(languages, (language) => {
                        return _createElementVNode("button", {
                          key: language.code,
                          type: "button",
                          class: "assistant-language-button",
                          onClick: ($event: any) => (selectLanguage(language.code))
                        }, _toDisplayString(language.label), 9, _hoisted_34)
                      }), 64))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createElementVNode("span", null, _toDisplayString(_unref(uiText).language), 1),
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(languages, (language) => {
                      return _createElementVNode("button", {
                        key: language.code,
                        type: "button",
                        class: _normalizeClass(["assistant-language-chip", {
                'assistant-language-chip--active':
                  selectedLanguage.value === language.code,
              }]),
                        disabled: isLoading.value || selectedLanguage.value === language.code,
                        onClick: ($event: any) => (selectLanguage(language.code))
                      }, _toDisplayString(language.shortLabel), 11, _hoisted_36)
                    }), 64))
                  ])),
              (bootstrapError.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(bootstrapError.value), 1))
                : _createCommentVNode("", true),
              (_unref(ncaStatusText))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    class: _normalizeClass(["assistant-alert", { 'assistant-alert--error': ncaStatus.value === 'UNAVAILABLE' }])
                  }, _toDisplayString(_unref(ncaStatusText)), 3))
                : _createCommentVNode("", true),
              (selectedLanguage.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_unref(uiText).welcome), 1))
                : _createCommentVNode("", true),
              (selectedLanguage.value && _unref(hasAssistantSuggestions))
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      (_unref(selectedCategory) || menuView.value !== 'page')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "assistant-menu-back",
                            disabled: isLoading.value,
                            onClick: goBackInMenu
                          }, _toDisplayString(_unref(uiText).back), 9, _hoisted_41))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_42, _toDisplayString(_unref(selectedCategory)
                      ? _unref(selectedCategory).title
                      : menuView.value === "pageQuestions"
                      ? _unref(uiText).allPageQuestions
                      : menuView.value === "allTopics" || !_unref(currentPageContext)
                      ? _unref(uiText).readyQuestions
                      : _unref(uiText).pageSuggestions), 1),
                        _createElementVNode("div", _hoisted_43, _toDisplayString(_unref(selectedCategory)
                      ? _unref(selectedCategory).description
                      : menuView.value === "pageQuestions"
                      ? _unref(uiText).allPageQuestionsHint
                      : menuView.value === "allTopics" || !_unref(currentPageContext)
                      ? _unref(uiText).chooseTopic
                      : _unref(uiText).pageSuggestionsHint), 1)
                      ])
                    ]),
                    (_unref(selectedCategory))
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(selectedCategory).items, (suggestion) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: getSuggestionKey(suggestion),
                            type: "button",
                            class: "assistant-menu-item",
                            disabled: isLoading.value,
                            onClick: ($event: any) => (sendSuggestion(suggestion))
                          }, _toDisplayString(suggestion.title), 9, _hoisted_44))
                        }), 128))
                      : (menuView.value === 'pageQuestions')
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(allContextualSuggestions), (suggestion) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: getSuggestionKey(suggestion),
                              type: "button",
                              class: "assistant-menu-item assistant-page-suggestion",
                              disabled: isLoading.value,
                              onClick: ($event: any) => (sendSuggestion(suggestion))
                            }, _toDisplayString(suggestion.title), 9, _hoisted_45))
                          }), 128))
                        : (menuView.value === 'allTopics' || !_unref(currentPageContext))
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_unref(allSuggestionCategories), (category) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: category.key,
                                type: "button",
                                class: "assistant-category",
                                disabled: isLoading.value,
                                onClick: ($event: any) => (openCategory(category.key, 'allTopics'))
                              }, [
                                _createElementVNode("span", _hoisted_47, _toDisplayString(category.title), 1),
                                _createElementVNode("span", _hoisted_48, _toDisplayString(formatQuestionCount(category.items.length)), 1)
                              ], 8, _hoisted_46))
                            }), 128))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contextualSuggestions), (suggestion) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  key: getSuggestionKey(suggestion),
                                  type: "button",
                                  class: "assistant-menu-item assistant-page-suggestion",
                                  disabled: isLoading.value,
                                  onClick: ($event: any) => (sendSuggestion(suggestion))
                                }, _toDisplayString(suggestion.title), 9, _hoisted_49))
                              }), 128)),
                              (_unref(relatedSuggestionCategories).length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                    _createElementVNode("div", _hoisted_51, [
                                      _createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_52, _toDisplayString(_unref(uiText).relatedTopics), 1),
                                        _createElementVNode("div", _hoisted_53, _toDisplayString(_unref(uiText).relatedTopicsHint), 1)
                                      ])
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(relatedSuggestionCategories), (category) => {
                                      return (_openBlock(), _createElementBlock("button", {
                                        key: category.key,
                                        type: "button",
                                        class: "assistant-category",
                                        disabled: isLoading.value,
                                        onClick: ($event: any) => (openCategory(category.key, 'page'))
                                      }, [
                                        _createElementVNode("span", _hoisted_55, _toDisplayString(category.title), 1),
                                        _createElementVNode("span", _hoisted_56, _toDisplayString(formatQuestionCount(category.items.length)), 1)
                                      ], 8, _hoisted_54))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true),
                              (_unref(hasMorePageQuestions) || _unref(hasMoreTopics))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                    (_unref(hasMorePageQuestions))
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          type: "button",
                                          class: "assistant-secondary-button",
                                          disabled: isLoading.value,
                                          onClick: _cache[5] || (_cache[5] = ($event: any) => (menuView.value = 'pageQuestions'))
                                        }, _toDisplayString(_unref(uiText).allPageQuestions), 9, _hoisted_58))
                                      : _createCommentVNode("", true),
                                    (_unref(hasMoreTopics))
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          type: "button",
                                          class: "assistant-secondary-button",
                                          disabled: isLoading.value,
                                          onClick: _cache[6] || (_cache[6] = ($event: any) => (menuView.value = 'allTopics'))
                                        }, _toDisplayString(_unref(uiText).allTopics), 9, _hoisted_59))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                  ]))
                : _createCommentVNode("", true)
            ], 512),
            _withDirectives(_createElementVNode("div", {
              class: _normalizeClass(["assistant-history", {
            'assistant-history--active': messages.value.length || isLoading.value,
          }]),
              ref: (_value, _refs) => {
                _refs['messagesContainer'] = _value
                messagesContainer.value = _value
              },
              onScrollPassive: handleHistoryScroll
            }, [
              (messages.value.length || isLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(_unref(uiText).dialogTitle), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (message) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: message.id,
                  class: _normalizeClass(["assistant-message", `assistant-message--${message.sender}`])
                }, [
                  (message.sender === 'assistant')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                        (assistantAvatarUrl.value)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: assistantAvatarUrl.value,
                              alt: ""
                            }, null, 8, _hoisted_62))
                          : (_openBlock(), _createElementBlock("span", _hoisted_63, "AI"))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, _toDisplayString(message.text), 1),
                    (message.actions && message.actions.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.actions, (action) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: `${message.id}-${action.type}-${action.value}`,
                              type: "button",
                              class: _normalizeClass(
                    action.type === 'DOWNLOAD_HR_DOCUMENT'
                      ? 'assistant-file-card'
                      : 'assistant-action'
                  ),
                              "aria-label": action.label,
                              title: 
                    action.type === 'DOWNLOAD_HR_DOCUMENT'
                      ? action.label
                      : undefined
                  ,
                              disabled: isLoading.value,
                              onClick: ($event: any) => (handleAction(action))
                            }, [
                              (action.type === 'DOWNLOAD_HR_DOCUMENT')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createVNode(_unref(DocumentTextIcon), {
                                      class: "assistant-file-icon",
                                      "aria-hidden": "true"
                                    }),
                                    _createElementVNode("span", _hoisted_68, [
                                      _createElementVNode("span", _hoisted_69, _toDisplayString(documentActionTitle(action)), 1),
                                      (documentActionFileName(action))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString(documentActionFileName(action)), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createVNode(_unref(ChevronRightIcon), {
                                      class: "assistant-file-arrow",
                                      "aria-hidden": "true"
                                    })
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(action.label), 1)
                                  ], 64))
                            ], 10, _hoisted_67))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (hrDocumentContinuation.value?.messageId === message.id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "assistant-action",
                            disabled: isLoading.value,
                            onClick: ($event: any) => (loadMoreDocuments(message.id))
                          }, _toDisplayString(hrAssistantTexts[_unref(currentLanguage)].showMore), 9, _hoisted_72)
                        ]))
                      : _createCommentVNode("", true),
                    (message.sender === 'assistant' && message.messageId)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                          (message.feedback === null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_74, _toDisplayString(_unref(uiText).answerHelpful), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            type: "button",
                            disabled: message.feedback !== null,
                            onClick: ($event: any) => (sendFeedback(message, true))
                          }, _toDisplayString(_unref(uiText).yes), 9, _hoisted_75),
                          _createElementVNode("button", {
                            type: "button",
                            disabled: message.feedback !== null,
                            onClick: ($event: any) => (sendFeedback(message, false))
                          }, _toDisplayString(_unref(uiText).no), 9, _hoisted_76),
                          (message.feedback !== null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_77, _toDisplayString(_unref(uiText).feedbackThanks), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 2))
              }), 128)),
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                    _createElementVNode("div", _hoisted_79, [
                      (assistantAvatarUrl.value)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: assistantAvatarUrl.value,
                            alt: ""
                          }, null, 8, _hoisted_80))
                        : (_openBlock(), _createElementBlock("span", _hoisted_81, "AI"))
                    ]),
                    _createElementVNode("div", _hoisted_82, [
                      _createElementVNode("div", _hoisted_83, _toDisplayString(_unref(uiText).loading), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (hrEmployeeSearch.value || hrDocumentSearch.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                    _createElementVNode("p", _hoisted_85, _toDisplayString(hrEmployeeSearch.value
                  ? hrAssistantTexts[_unref(currentLanguage)].employeeSearchHint
                  : hrAssistantTexts[_unref(currentLanguage)].documentSearchHint), 1),
                    _createElementVNode("div", _hoisted_86, [
                      (hrDocumentSearch.value && _unref(canSearchHrEmployees))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "assistant-action",
                            disabled: isLoading.value,
                            onClick: startEmployeeSearch
                          }, _toDisplayString(hrAssistantTexts[_unref(currentLanguage)].otherEmployee), 9, _hoisted_87))
                        : _createCommentVNode("", true),
                      (hrEmployeeContextId.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "assistant-action",
                            disabled: isLoading.value,
                            onClick: promptDocumentSearch
                          }, _toDisplayString(hrAssistantTexts[_unref(currentLanguage)].otherDocument), 9, _hoisted_88))
                        : _createCommentVNode("", true),
                      (hrEmployeeContextId.value && _unref(canSearchHrDocuments))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            type: "button",
                            class: "assistant-action",
                            disabled: isLoading.value,
                            onClick: showAllEmployeeDocuments
                          }, _toDisplayString(hrAssistantTexts[_unref(currentLanguage)].allEmployeeDocuments), 9, _hoisted_89))
                        : _createCommentVNode("", true),
                      (
                  hrEmployeeContextId.value &&
                  (canSearchUnclassifiedDocuments.value || hrUnclassifiedSearch.value)
                )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 3,
                            type: "button",
                            class: "assistant-action",
                            disabled: isLoading.value,
                            onClick: toggleUnclassifiedDocuments
                          }, _toDisplayString(hrUnclassifiedSearch.value
                    ? hrAssistantTexts[_unref(currentLanguage)].showClassified
                    : hrAssistantTexts[_unref(currentLanguage)].showUnclassified), 9, _hoisted_90))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        type: "button",
                        class: "assistant-action",
                        disabled: isLoading.value,
                        onClick: finishHrSearch
                      }, _toDisplayString(hrAssistantTexts[_unref(currentLanguage)].finishSearch), 9, _hoisted_91)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 34), [
              [_vShow, _unref(hasConversation)]
            ])
          ], 2),
          _createElementVNode("form", {
            class: "assistant-form",
            onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (sendMessage()), ["prevent"]))
          }, [
            (selectedLanguage.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "assistant-support-link",
                    disabled: isLoading.value,
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (openSupportForm()))
                  }, _toDisplayString(_unref(supportUiText).open), 9, _hoisted_93),
                  _createElementVNode("button", {
                    type: "button",
                    class: "assistant-support-link",
                    disabled: isLoading.value,
                    onClick: openMyTickets
                  }, _toDisplayString(_unref(supportUiText).myTickets), 9, _hoisted_94)
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("textarea", {
              ref: (_value, _refs) => {
                _refs['messageInput'] = _value
                messageInput.value = _value
              },
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((inputText).value = $event)),
              maxlength: "500",
              rows: "2",
              "aria-label": _unref(uiText).placeholder,
              placeholder: 
            selectedLanguage.value ? _unref(uiText).placeholder : _unref(uiText).chooseLanguageFirst
          ,
              disabled: isLoading.value || !selectedLanguage.value,
              onFocus: _cache[9] || (_cache[9] = ($event: any) => (mobileSuggestionsOpen.value = false)),
              onKeydown: _withKeys(_withModifiers(handleInputEnter, ["exact"]), ["enter"])
            }, null, 40, _hoisted_95), [
              [_vModelText, inputText.value]
            ]),
            _createElementVNode("button", {
              type: "submit",
              class: "assistant-send",
              disabled: isLoading.value || !selectedLanguage.value || !inputText.value.trim()
            }, _toDisplayString(_unref(uiText).send), 9, _hoisted_96)
          ], 32)
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      type: "button",
      class: "assistant-launcher",
      "aria-expanded": isOpen.value,
      "aria-label": _unref(uiText).open,
      onClick: toggleAssistant
    }, [
      _hoisted_98,
      (hasUnreadErrorHint.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_99))
        : _createCommentVNode("", true)
    ], 8, _hoisted_97)
  ], 6))
}
}

})